/* eslint-disable */
// This code was auto-generated by running
// yarn generate:types
// Please do not modify this code by hand.

'use strict';
exports.validateAPIDashboard = validate10;
const schema11 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'APIDashboard.json',
  title: 'APIDashboard',
  type: 'object',
  oneOf: [
    { $ref: 'APIUsageData.json' },
    { $ref: 'SignatureRequestUsageData.json' },
    { $ref: 'SignatureRequestStatusData.json' },
    { $ref: 'APIUsageData.json' },
    { $ref: 'APIAccountData.json' },
    { $ref: 'APICallbacksData.json' },
    { $ref: 'APIRequestsData.json' },
    { $ref: 'APICallbackData.json' },
    { $ref: 'APIEventTypesData.json' },
    { $ref: 'APIRequestsHTTPStatusData.json' },
    { $ref: 'APIEndpointListData.json' },
    { $ref: 'APIRequestsErrorDistributionData.json' },
    { $ref: 'APISignatureRequestsData.json' },
    { $ref: 'APISearchResultData.json' },
    { $ref: 'APISignatureRequestsData.json' },
    { $ref: 'APIIncidentsData.json' },
    { $ref: 'APIRequestsEndpointData.json' },
    { $ref: 'TeamAccountsData.json' },
  ],
};
const schema12 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'APIUsageData.json',
  type: 'object',
  title: 'APIUsageData',
  properties: {
    account_id: { type: 'string' },
    items: {
      type: 'array',
      items: {
        properties: { count: { type: 'number' }, date: { type: 'string' } },
        required: ['count', 'date'],
      },
    },
    last_day: { type: 'number' },
    range: { type: 'string' },
    total: { type: 'number' },
  },
  required: ['account_id', 'last_day', 'range', 'total'],
};
const schema13 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'SignatureRequestUsageData.json',
  type: 'object',
  title: 'SignatureRequestUsageData',
  properties: {
    x: { type: 'array', items: { type: 'string' } },
    y: { type: 'array', items: { type: 'number' } },
    client_ids: { type: 'array', items: { type: 'string' } },
  },
  required: ['x', 'y'],
};
const schema17 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'APIAccountData.json',
  type: 'object',
  title: 'APIAccountData',
  properties: {
    account_id: { type: 'string' },
    emailAddress: { type: 'string' },
    timezone_info: {
      type: 'object',
      properties: {
        abbreviation: { type: 'string' },
        display_name: { type: 'string' },
        gmt_offset: { type: 'number' },
        has_dst: { type: 'number' },
        matching_identifier: { type: 'string' },
      },
    },
    billing: {
      type: 'object',
      properties: {
        next_refresh_date: { type: ['string', 'null'] },
        next_billing_date: { type: ['string', 'null'] },
        plan_name: { type: 'string' },
      },
    },
    quotas: {
      type: 'object',
      properties: {
        templates_left: { type: ['number', 'null'] },
        documents_left: { type: ['number', 'null'] },
        api_signature_requests_left: { type: ['number', 'null'] },
        all_signature_requests_left: { type: ['number', 'null'] },
        all_signature_requests_total: { type: ['number', 'null'] },
        templates_total: { type: ['number', 'null'] },
        sms_verifications_left: { type: ['number', 'null'] },
        sms_verifications_total: { type: ['number', 'null'] },
        api_signature_requests_used: { type: ['number', 'null'] },
        api_signature_requests_total: { type: ['number', 'null'] },
      },
    },
  },
  required: ['timezone_info'],
};
const schema18 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'APICallbacksData.json',
  type: 'object',
  title: 'APICallbacksData',
  properties: {
    items: {
      type: 'array',
      items: {
        properties: {
          id: { type: 'string' },
          received: { type: 'boolean' },
          timestamp: { type: 'number' },
          type: { type: 'string' },
        },
        required: ['id', 'received', 'timestamp', 'type'],
      },
    },
    count: { type: 'number' },
    page_size: { type: 'number' },
  },
  required: ['count', 'page_size'],
};
const schema19 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'APIRequestsData.json',
  type: 'object',
  title: 'APIRequestsData',
  properties: {
    items: {
      type: 'array',
      items: {
        properties: {
          id: { type: 'string' },
          method: { type: 'string' },
          path: { type: 'string' },
          status: { type: 'number' },
          timestamp: { type: 'number' },
        },
        required: ['id', 'method', 'path', 'status', 'timestamp'],
      },
    },
    count: { type: 'number' },
    page_size: { type: 'number' },
  },
  required: ['count', 'page_size'],
};
const schema20 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'APICallbackData.json',
  type: 'object',
  title: 'APICallbackData',
  properties: {
    attempts: {
      type: 'array',
      items: {
        properties: {
          error: { type: ['string', 'null'] },
          url: { type: ['string', 'null'] },
          status_code: { type: ['number', 'null'] },
          response: { type: ['string', 'null'] },
          success: { type: 'boolean' },
          timestamp: { type: 'number' },
        },
        required: [
          'error',
          'status_code',
          'response',
          'success',
          'timestamp',
          'url',
        ],
      },
    },
    event_data: { type: ['string', 'null'] },
    id: { type: ['string', 'null'] },
    timestamp: { type: 'number' },
    type: { type: ['string', 'null'] },
  },
  required: ['event_data', 'id', 'timestamp', 'type'],
};
const schema21 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'APIEventTypesData.json',
  type: 'array',
  title: 'APIEventTypesData',
  items: { type: 'string' },
};
const schema24 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'APIEndpointListData.json',
  type: 'array',
  title: 'APIEndpointListData',
  items: {
    type: 'object',
    properties: {
      key: { type: 'string' },
      value: { type: 'string' },
      isSelected: { type: 'boolean' },
    },
    required: ['key', 'value', 'isSelected'],
  },
};
const schema25 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'APIRequestsErrorDistributionData.json',
  type: 'object',
  title: 'APIRequestsErrorDistributionData',
  properties: {
    success_data: { type: 'array', items: { type: 'number' } },
    failure_data: { type: 'array', items: { type: 'number' } },
    dates: { type: 'array', items: { type: 'string' } },
  },
  required: ['success_data', 'failure_data', 'dates'],
};
const schema26 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'APISignatureRequestsData.json',
  type: 'object',
  title: 'APISignatureRequestsData',
  properties: {
    items: {
      type: 'array',
      items: {
        properties: {
          id: { type: 'string' },
          status: { type: 'string' },
          timestamp: { type: 'number' },
        },
        required: ['id', 'status', 'timestamp'],
      },
    },
    count: { type: 'number' },
    page_size: { type: 'number' },
  },
  required: ['count', 'page_size'],
};
const schema27 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'APISearchResultData.json',
  type: 'object',
  title: 'APISearchResultData',
  properties: {
    page_size: { type: 'number' },
    result_counts: {
      type: 'object',
      properties: {
        signature_request: { type: 'number' },
        api_request: { type: 'number' },
        account_callback: { type: 'number' },
        app_callback: { type: 'number' },
      },
      required: [
        'signature_request',
        'api_request',
        'account_callback',
        'app_callback',
      ],
    },
  },
  required: ['result_counts'],
};
const schema14 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'SignatureRequestStatusData.json',
  type: 'object',
  title: 'SignatureRequestStatusData',
  properties: { data: { type: 'array', items: { $ref: 'NameYDataSet.json' } } },
  required: ['data'],
};
const schema15 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'NameYDataSet.json',
  type: 'object',
  title: 'NameYDataSet',
  properties: { name: { type: 'string' }, y: { type: 'number' } },
  required: ['name', 'y'],
};
function validate11(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="SignatureRequestStatusData.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (data.data === undefined && (missing0 = 'data')) {
        validate11.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.data !== undefined) {
          let data0 = data.data;
          const _errs1 = errors;
          if (errors === _errs1) {
            if (Array.isArray(data0)) {
              var valid1 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                let data1 = data0[i0];
                const _errs3 = errors;
                const _errs4 = errors;
                if (errors === _errs4) {
                  if (
                    data1 &&
                    typeof data1 == 'object' &&
                    !Array.isArray(data1)
                  ) {
                    let missing1;
                    if (
                      (data1.name === undefined && (missing1 = 'name')) ||
                      (data1.y === undefined && (missing1 = 'y'))
                    ) {
                      validate11.errors = [
                        {
                          instancePath: instancePath + '/data/' + i0,
                          schemaPath: 'NameYDataSet.json/required',
                          keyword: 'required',
                          params: { missingProperty: missing1 },
                          message:
                            "must have required property '" + missing1 + "'",
                        },
                      ];
                      return false;
                    } else {
                      if (data1.name !== undefined) {
                        const _errs6 = errors;
                        if (typeof data1.name !== 'string') {
                          validate11.errors = [
                            {
                              instancePath:
                                instancePath + '/data/' + i0 + '/name',
                              schemaPath:
                                'NameYDataSet.json/properties/name/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid3 = _errs6 === errors;
                      } else {
                        var valid3 = true;
                      }
                      if (valid3) {
                        if (data1.y !== undefined) {
                          let data3 = data1.y;
                          const _errs8 = errors;
                          if (!(typeof data3 == 'number' && isFinite(data3))) {
                            validate11.errors = [
                              {
                                instancePath:
                                  instancePath + '/data/' + i0 + '/y',
                                schemaPath:
                                  'NameYDataSet.json/properties/y/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number',
                              },
                            ];
                            return false;
                          }
                          var valid3 = _errs8 === errors;
                        } else {
                          var valid3 = true;
                        }
                      }
                    }
                  } else {
                    validate11.errors = [
                      {
                        instancePath: instancePath + '/data/' + i0,
                        schemaPath: 'NameYDataSet.json/type',
                        keyword: 'type',
                        params: { type: 'object' },
                        message: 'must be object',
                      },
                    ];
                    return false;
                  }
                }
                var valid1 = _errs3 === errors;
                if (!valid1) {
                  break;
                }
              }
            } else {
              validate11.errors = [
                {
                  instancePath: instancePath + '/data',
                  schemaPath: '#/properties/data/type',
                  keyword: 'type',
                  params: { type: 'array' },
                  message: 'must be array',
                },
              ];
              return false;
            }
          }
        }
      }
    } else {
      validate11.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate11.errors = vErrors;
  return errors === 0;
}
const schema22 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'APIRequestsHTTPStatusData.json',
  type: 'object',
  title: 'APIRequestsHTTPStatusData',
  properties: {
    statuses: { type: 'array', items: { $ref: 'NameYDataSet.json' } },
  },
  required: ['statuses'],
};
function validate13(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="APIRequestsHTTPStatusData.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (data.statuses === undefined && (missing0 = 'statuses')) {
        validate13.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.statuses !== undefined) {
          let data0 = data.statuses;
          const _errs1 = errors;
          if (errors === _errs1) {
            if (Array.isArray(data0)) {
              var valid1 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                let data1 = data0[i0];
                const _errs3 = errors;
                const _errs4 = errors;
                if (errors === _errs4) {
                  if (
                    data1 &&
                    typeof data1 == 'object' &&
                    !Array.isArray(data1)
                  ) {
                    let missing1;
                    if (
                      (data1.name === undefined && (missing1 = 'name')) ||
                      (data1.y === undefined && (missing1 = 'y'))
                    ) {
                      validate13.errors = [
                        {
                          instancePath: instancePath + '/statuses/' + i0,
                          schemaPath: 'NameYDataSet.json/required',
                          keyword: 'required',
                          params: { missingProperty: missing1 },
                          message:
                            "must have required property '" + missing1 + "'",
                        },
                      ];
                      return false;
                    } else {
                      if (data1.name !== undefined) {
                        const _errs6 = errors;
                        if (typeof data1.name !== 'string') {
                          validate13.errors = [
                            {
                              instancePath:
                                instancePath + '/statuses/' + i0 + '/name',
                              schemaPath:
                                'NameYDataSet.json/properties/name/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid3 = _errs6 === errors;
                      } else {
                        var valid3 = true;
                      }
                      if (valid3) {
                        if (data1.y !== undefined) {
                          let data3 = data1.y;
                          const _errs8 = errors;
                          if (!(typeof data3 == 'number' && isFinite(data3))) {
                            validate13.errors = [
                              {
                                instancePath:
                                  instancePath + '/statuses/' + i0 + '/y',
                                schemaPath:
                                  'NameYDataSet.json/properties/y/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number',
                              },
                            ];
                            return false;
                          }
                          var valid3 = _errs8 === errors;
                        } else {
                          var valid3 = true;
                        }
                      }
                    }
                  } else {
                    validate13.errors = [
                      {
                        instancePath: instancePath + '/statuses/' + i0,
                        schemaPath: 'NameYDataSet.json/type',
                        keyword: 'type',
                        params: { type: 'object' },
                        message: 'must be object',
                      },
                    ];
                    return false;
                  }
                }
                var valid1 = _errs3 === errors;
                if (!valid1) {
                  break;
                }
              }
            } else {
              validate13.errors = [
                {
                  instancePath: instancePath + '/statuses',
                  schemaPath: '#/properties/statuses/type',
                  keyword: 'type',
                  params: { type: 'array' },
                  message: 'must be array',
                },
              ];
              return false;
            }
          }
        }
      }
    } else {
      validate13.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate13.errors = vErrors;
  return errors === 0;
}
const schema29 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'APIIncidentsData.json',
  type: 'object',
  title: 'APIIncidentsData',
  properties: {
    component: {
      type: 'object',
      properties: { status: { $ref: '#/definitions/ComponentStatus' } },
      required: ['status'],
    },
    incidents: {
      type: 'array',
      items: {
        properties: {
          name: { type: 'string' },
          status: { $ref: '#/definitions/IncidentStatus' },
          shortlink: { type: 'string' },
          incident_updates: {
            type: 'array',
            items: {
              properties: {
                body: { type: 'string' },
                status: { $ref: '#/definitions/IncidentStatus' },
                updated_at: { type: 'string' },
              },
              required: ['body', 'status', 'updated_at'],
            },
          },
          scheduled_for: { type: 'string' },
          scheduled_until: { type: 'string' },
        },
        required: ['name', 'status', 'shortlink', 'incident_updates'],
      },
    },
  },
  required: ['incidents'],
  definitions: {
    IncidentStatus: {
      type: 'string',
      enum: [
        'investigating',
        'identified',
        'monitoring',
        'resolved',
        'scheduled',
        'in_progress',
        'verifying',
        'completed',
      ],
    },
    ComponentStatus: {
      type: 'string',
      enum: [
        'operational',
        'degraded_performance',
        'partial_outage',
        'major_outage',
        'under_maintenance',
      ],
    },
  },
};
const schema30 = {
  type: 'string',
  enum: [
    'operational',
    'degraded_performance',
    'partial_outage',
    'major_outage',
    'under_maintenance',
  ],
};
const schema31 = {
  type: 'string',
  enum: [
    'investigating',
    'identified',
    'monitoring',
    'resolved',
    'scheduled',
    'in_progress',
    'verifying',
    'completed',
  ],
};
function validate15(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="APIIncidentsData.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (data.incidents === undefined && (missing0 = 'incidents')) {
        validate15.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.component !== undefined) {
          let data0 = data.component;
          const _errs1 = errors;
          if (errors === _errs1) {
            if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
              let missing1;
              if (data0.status === undefined && (missing1 = 'status')) {
                validate15.errors = [
                  {
                    instancePath: instancePath + '/component',
                    schemaPath: '#/properties/component/required',
                    keyword: 'required',
                    params: { missingProperty: missing1 },
                    message: "must have required property '" + missing1 + "'",
                  },
                ];
                return false;
              } else {
                if (data0.status !== undefined) {
                  let data1 = data0.status;
                  if (typeof data1 !== 'string') {
                    validate15.errors = [
                      {
                        instancePath: instancePath + '/component/status',
                        schemaPath: '#/definitions/ComponentStatus/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  if (
                    !(
                      data1 === 'operational' ||
                      data1 === 'degraded_performance' ||
                      data1 === 'partial_outage' ||
                      data1 === 'major_outage' ||
                      data1 === 'under_maintenance'
                    )
                  ) {
                    validate15.errors = [
                      {
                        instancePath: instancePath + '/component/status',
                        schemaPath: '#/definitions/ComponentStatus/enum',
                        keyword: 'enum',
                        params: { allowedValues: schema30.enum },
                        message: 'must be equal to one of the allowed values',
                      },
                    ];
                    return false;
                  }
                }
              }
            } else {
              validate15.errors = [
                {
                  instancePath: instancePath + '/component',
                  schemaPath: '#/properties/component/type',
                  keyword: 'type',
                  params: { type: 'object' },
                  message: 'must be object',
                },
              ];
              return false;
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.incidents !== undefined) {
            let data2 = data.incidents;
            const _errs6 = errors;
            if (errors === _errs6) {
              if (Array.isArray(data2)) {
                var valid3 = true;
                const len0 = data2.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  let data3 = data2[i0];
                  const _errs8 = errors;
                  if (
                    data3 &&
                    typeof data3 == 'object' &&
                    !Array.isArray(data3)
                  ) {
                    let missing2;
                    if (
                      (data3.name === undefined && (missing2 = 'name')) ||
                      (data3.status === undefined && (missing2 = 'status')) ||
                      (data3.shortlink === undefined &&
                        (missing2 = 'shortlink')) ||
                      (data3.incident_updates === undefined &&
                        (missing2 = 'incident_updates'))
                    ) {
                      validate15.errors = [
                        {
                          instancePath: instancePath + '/incidents/' + i0,
                          schemaPath: '#/properties/incidents/items/required',
                          keyword: 'required',
                          params: { missingProperty: missing2 },
                          message:
                            "must have required property '" + missing2 + "'",
                        },
                      ];
                      return false;
                    } else {
                      if (data3.name !== undefined) {
                        const _errs9 = errors;
                        if (typeof data3.name !== 'string') {
                          validate15.errors = [
                            {
                              instancePath:
                                instancePath + '/incidents/' + i0 + '/name',
                              schemaPath:
                                '#/properties/incidents/items/properties/name/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid4 = _errs9 === errors;
                      } else {
                        var valid4 = true;
                      }
                      if (valid4) {
                        if (data3.status !== undefined) {
                          let data5 = data3.status;
                          const _errs11 = errors;
                          if (typeof data5 !== 'string') {
                            validate15.errors = [
                              {
                                instancePath:
                                  instancePath + '/incidents/' + i0 + '/status',
                                schemaPath: '#/definitions/IncidentStatus/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          if (
                            !(
                              data5 === 'investigating' ||
                              data5 === 'identified' ||
                              data5 === 'monitoring' ||
                              data5 === 'resolved' ||
                              data5 === 'scheduled' ||
                              data5 === 'in_progress' ||
                              data5 === 'verifying' ||
                              data5 === 'completed'
                            )
                          ) {
                            validate15.errors = [
                              {
                                instancePath:
                                  instancePath + '/incidents/' + i0 + '/status',
                                schemaPath: '#/definitions/IncidentStatus/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema31.enum },
                                message:
                                  'must be equal to one of the allowed values',
                              },
                            ];
                            return false;
                          }
                          var valid4 = _errs11 === errors;
                        } else {
                          var valid4 = true;
                        }
                        if (valid4) {
                          if (data3.shortlink !== undefined) {
                            const _errs14 = errors;
                            if (typeof data3.shortlink !== 'string') {
                              validate15.errors = [
                                {
                                  instancePath:
                                    instancePath +
                                    '/incidents/' +
                                    i0 +
                                    '/shortlink',
                                  schemaPath:
                                    '#/properties/incidents/items/properties/shortlink/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                },
                              ];
                              return false;
                            }
                            var valid4 = _errs14 === errors;
                          } else {
                            var valid4 = true;
                          }
                          if (valid4) {
                            if (data3.incident_updates !== undefined) {
                              let data7 = data3.incident_updates;
                              const _errs16 = errors;
                              if (errors === _errs16) {
                                if (Array.isArray(data7)) {
                                  var valid6 = true;
                                  const len1 = data7.length;
                                  for (let i1 = 0; i1 < len1; i1++) {
                                    let data8 = data7[i1];
                                    const _errs18 = errors;
                                    if (
                                      data8 &&
                                      typeof data8 == 'object' &&
                                      !Array.isArray(data8)
                                    ) {
                                      let missing3;
                                      if (
                                        (data8.body === undefined &&
                                          (missing3 = 'body')) ||
                                        (data8.status === undefined &&
                                          (missing3 = 'status')) ||
                                        (data8.updated_at === undefined &&
                                          (missing3 = 'updated_at'))
                                      ) {
                                        validate15.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/incidents/' +
                                              i0 +
                                              '/incident_updates/' +
                                              i1,
                                            schemaPath:
                                              '#/properties/incidents/items/properties/incident_updates/items/required',
                                            keyword: 'required',
                                            params: {
                                              missingProperty: missing3,
                                            },
                                            message:
                                              "must have required property '" +
                                              missing3 +
                                              "'",
                                          },
                                        ];
                                        return false;
                                      } else {
                                        if (data8.body !== undefined) {
                                          const _errs19 = errors;
                                          if (typeof data8.body !== 'string') {
                                            validate15.errors = [
                                              {
                                                instancePath:
                                                  instancePath +
                                                  '/incidents/' +
                                                  i0 +
                                                  '/incident_updates/' +
                                                  i1 +
                                                  '/body',
                                                schemaPath:
                                                  '#/properties/incidents/items/properties/incident_updates/items/properties/body/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid7 = _errs19 === errors;
                                        } else {
                                          var valid7 = true;
                                        }
                                        if (valid7) {
                                          if (data8.status !== undefined) {
                                            let data10 = data8.status;
                                            const _errs21 = errors;
                                            if (typeof data10 !== 'string') {
                                              validate15.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/incidents/' +
                                                    i0 +
                                                    '/incident_updates/' +
                                                    i1 +
                                                    '/status',
                                                  schemaPath:
                                                    '#/definitions/IncidentStatus/type',
                                                  keyword: 'type',
                                                  params: { type: 'string' },
                                                  message: 'must be string',
                                                },
                                              ];
                                              return false;
                                            }
                                            if (
                                              !(
                                                data10 === 'investigating' ||
                                                data10 === 'identified' ||
                                                data10 === 'monitoring' ||
                                                data10 === 'resolved' ||
                                                data10 === 'scheduled' ||
                                                data10 === 'in_progress' ||
                                                data10 === 'verifying' ||
                                                data10 === 'completed'
                                              )
                                            ) {
                                              validate15.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/incidents/' +
                                                    i0 +
                                                    '/incident_updates/' +
                                                    i1 +
                                                    '/status',
                                                  schemaPath:
                                                    '#/definitions/IncidentStatus/enum',
                                                  keyword: 'enum',
                                                  params: {
                                                    allowedValues:
                                                      schema31.enum,
                                                  },
                                                  message:
                                                    'must be equal to one of the allowed values',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid7 = _errs21 === errors;
                                          } else {
                                            var valid7 = true;
                                          }
                                          if (valid7) {
                                            if (
                                              data8.updated_at !== undefined
                                            ) {
                                              const _errs24 = errors;
                                              if (
                                                typeof data8.updated_at !==
                                                'string'
                                              ) {
                                                validate15.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/incidents/' +
                                                      i0 +
                                                      '/incident_updates/' +
                                                      i1 +
                                                      '/updated_at',
                                                    schemaPath:
                                                      '#/properties/incidents/items/properties/incident_updates/items/properties/updated_at/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string',
                                                  },
                                                ];
                                                return false;
                                              }
                                              var valid7 = _errs24 === errors;
                                            } else {
                                              var valid7 = true;
                                            }
                                          }
                                        }
                                      }
                                    }
                                    var valid6 = _errs18 === errors;
                                    if (!valid6) {
                                      break;
                                    }
                                  }
                                } else {
                                  validate15.errors = [
                                    {
                                      instancePath:
                                        instancePath +
                                        '/incidents/' +
                                        i0 +
                                        '/incident_updates',
                                      schemaPath:
                                        '#/properties/incidents/items/properties/incident_updates/type',
                                      keyword: 'type',
                                      params: { type: 'array' },
                                      message: 'must be array',
                                    },
                                  ];
                                  return false;
                                }
                              }
                              var valid4 = _errs16 === errors;
                            } else {
                              var valid4 = true;
                            }
                            if (valid4) {
                              if (data3.scheduled_for !== undefined) {
                                const _errs26 = errors;
                                if (typeof data3.scheduled_for !== 'string') {
                                  validate15.errors = [
                                    {
                                      instancePath:
                                        instancePath +
                                        '/incidents/' +
                                        i0 +
                                        '/scheduled_for',
                                      schemaPath:
                                        '#/properties/incidents/items/properties/scheduled_for/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    },
                                  ];
                                  return false;
                                }
                                var valid4 = _errs26 === errors;
                              } else {
                                var valid4 = true;
                              }
                              if (valid4) {
                                if (data3.scheduled_until !== undefined) {
                                  const _errs28 = errors;
                                  if (
                                    typeof data3.scheduled_until !== 'string'
                                  ) {
                                    validate15.errors = [
                                      {
                                        instancePath:
                                          instancePath +
                                          '/incidents/' +
                                          i0 +
                                          '/scheduled_until',
                                        schemaPath:
                                          '#/properties/incidents/items/properties/scheduled_until/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid4 = _errs28 === errors;
                                } else {
                                  var valid4 = true;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                  var valid3 = _errs8 === errors;
                  if (!valid3) {
                    break;
                  }
                }
              } else {
                validate15.errors = [
                  {
                    instancePath: instancePath + '/incidents',
                    schemaPath: '#/properties/incidents/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                  },
                ];
                return false;
              }
            }
            var valid0 = _errs6 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate15.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate15.errors = vErrors;
  return errors === 0;
}
const schema33 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'APIRequestsEndpointData.json',
  type: 'object',
  title: 'APIRequestsEndpointData',
  properties: {
    success_data: { type: 'array', items: { $ref: 'NameYDataSet.json' } },
    failure_data: { type: 'array', items: { $ref: 'NameYDataSet.json' } },
    urls: { type: 'array', items: { type: 'string' } },
  },
  required: ['success_data', 'failure_data', 'urls'],
};
function validate17(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="APIRequestsEndpointData.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.success_data === undefined && (missing0 = 'success_data')) ||
        (data.failure_data === undefined && (missing0 = 'failure_data')) ||
        (data.urls === undefined && (missing0 = 'urls'))
      ) {
        validate17.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.success_data !== undefined) {
          let data0 = data.success_data;
          const _errs1 = errors;
          if (errors === _errs1) {
            if (Array.isArray(data0)) {
              var valid1 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                let data1 = data0[i0];
                const _errs3 = errors;
                const _errs4 = errors;
                if (errors === _errs4) {
                  if (
                    data1 &&
                    typeof data1 == 'object' &&
                    !Array.isArray(data1)
                  ) {
                    let missing1;
                    if (
                      (data1.name === undefined && (missing1 = 'name')) ||
                      (data1.y === undefined && (missing1 = 'y'))
                    ) {
                      validate17.errors = [
                        {
                          instancePath: instancePath + '/success_data/' + i0,
                          schemaPath: 'NameYDataSet.json/required',
                          keyword: 'required',
                          params: { missingProperty: missing1 },
                          message:
                            "must have required property '" + missing1 + "'",
                        },
                      ];
                      return false;
                    } else {
                      if (data1.name !== undefined) {
                        const _errs6 = errors;
                        if (typeof data1.name !== 'string') {
                          validate17.errors = [
                            {
                              instancePath:
                                instancePath + '/success_data/' + i0 + '/name',
                              schemaPath:
                                'NameYDataSet.json/properties/name/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid3 = _errs6 === errors;
                      } else {
                        var valid3 = true;
                      }
                      if (valid3) {
                        if (data1.y !== undefined) {
                          let data3 = data1.y;
                          const _errs8 = errors;
                          if (!(typeof data3 == 'number' && isFinite(data3))) {
                            validate17.errors = [
                              {
                                instancePath:
                                  instancePath + '/success_data/' + i0 + '/y',
                                schemaPath:
                                  'NameYDataSet.json/properties/y/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number',
                              },
                            ];
                            return false;
                          }
                          var valid3 = _errs8 === errors;
                        } else {
                          var valid3 = true;
                        }
                      }
                    }
                  } else {
                    validate17.errors = [
                      {
                        instancePath: instancePath + '/success_data/' + i0,
                        schemaPath: 'NameYDataSet.json/type',
                        keyword: 'type',
                        params: { type: 'object' },
                        message: 'must be object',
                      },
                    ];
                    return false;
                  }
                }
                var valid1 = _errs3 === errors;
                if (!valid1) {
                  break;
                }
              }
            } else {
              validate17.errors = [
                {
                  instancePath: instancePath + '/success_data',
                  schemaPath: '#/properties/success_data/type',
                  keyword: 'type',
                  params: { type: 'array' },
                  message: 'must be array',
                },
              ];
              return false;
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.failure_data !== undefined) {
            let data4 = data.failure_data;
            const _errs10 = errors;
            if (errors === _errs10) {
              if (Array.isArray(data4)) {
                var valid4 = true;
                const len1 = data4.length;
                for (let i1 = 0; i1 < len1; i1++) {
                  let data5 = data4[i1];
                  const _errs12 = errors;
                  const _errs13 = errors;
                  if (errors === _errs13) {
                    if (
                      data5 &&
                      typeof data5 == 'object' &&
                      !Array.isArray(data5)
                    ) {
                      let missing2;
                      if (
                        (data5.name === undefined && (missing2 = 'name')) ||
                        (data5.y === undefined && (missing2 = 'y'))
                      ) {
                        validate17.errors = [
                          {
                            instancePath: instancePath + '/failure_data/' + i1,
                            schemaPath: 'NameYDataSet.json/required',
                            keyword: 'required',
                            params: { missingProperty: missing2 },
                            message:
                              "must have required property '" + missing2 + "'",
                          },
                        ];
                        return false;
                      } else {
                        if (data5.name !== undefined) {
                          const _errs15 = errors;
                          if (typeof data5.name !== 'string') {
                            validate17.errors = [
                              {
                                instancePath:
                                  instancePath +
                                  '/failure_data/' +
                                  i1 +
                                  '/name',
                                schemaPath:
                                  'NameYDataSet.json/properties/name/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid6 = _errs15 === errors;
                        } else {
                          var valid6 = true;
                        }
                        if (valid6) {
                          if (data5.y !== undefined) {
                            let data7 = data5.y;
                            const _errs17 = errors;
                            if (
                              !(typeof data7 == 'number' && isFinite(data7))
                            ) {
                              validate17.errors = [
                                {
                                  instancePath:
                                    instancePath + '/failure_data/' + i1 + '/y',
                                  schemaPath:
                                    'NameYDataSet.json/properties/y/type',
                                  keyword: 'type',
                                  params: { type: 'number' },
                                  message: 'must be number',
                                },
                              ];
                              return false;
                            }
                            var valid6 = _errs17 === errors;
                          } else {
                            var valid6 = true;
                          }
                        }
                      }
                    } else {
                      validate17.errors = [
                        {
                          instancePath: instancePath + '/failure_data/' + i1,
                          schemaPath: 'NameYDataSet.json/type',
                          keyword: 'type',
                          params: { type: 'object' },
                          message: 'must be object',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid4 = _errs12 === errors;
                  if (!valid4) {
                    break;
                  }
                }
              } else {
                validate17.errors = [
                  {
                    instancePath: instancePath + '/failure_data',
                    schemaPath: '#/properties/failure_data/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                  },
                ];
                return false;
              }
            }
            var valid0 = _errs10 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.urls !== undefined) {
              let data8 = data.urls;
              const _errs19 = errors;
              if (errors === _errs19) {
                if (Array.isArray(data8)) {
                  var valid7 = true;
                  const len2 = data8.length;
                  for (let i2 = 0; i2 < len2; i2++) {
                    const _errs21 = errors;
                    if (typeof data8[i2] !== 'string') {
                      validate17.errors = [
                        {
                          instancePath: instancePath + '/urls/' + i2,
                          schemaPath: '#/properties/urls/items/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                    var valid7 = _errs21 === errors;
                    if (!valid7) {
                      break;
                    }
                  }
                } else {
                  validate17.errors = [
                    {
                      instancePath: instancePath + '/urls',
                      schemaPath: '#/properties/urls/type',
                      keyword: 'type',
                      params: { type: 'array' },
                      message: 'must be array',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs19 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate17.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate17.errors = vErrors;
  return errors === 0;
}
const schema36 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'TeamAccountsData.json',
  type: 'object',
  title: 'TeamAccountsData',
  properties: {
    team_accounts: { type: 'array', items: { $ref: 'TeamData.json' } },
  },
  required: ['team_accounts'],
};
const schema37 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'TeamData.json',
  type: 'object',
  title: 'TeamData',
  properties: {
    team_guid: { type: 'string' },
    team_name: { type: 'string' },
    role: { type: 'string' },
    accounts: { type: 'array', items: { $ref: 'AccountData.json' } },
  },
  required: ['team_guid', 'team_name', 'accounts'],
};
const schema38 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'AccountData.json',
  type: 'object',
  title: 'AccountData',
  properties: {
    account_guid: { type: 'string' },
    first_name: { type: ['string', 'null'] },
    last_name: { type: ['string', 'null'] },
    email_address: { type: 'string' },
    role: { type: 'string' },
  },
  required: ['account_guid', 'email_address'],
};
function validate20(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="TeamData.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.team_guid === undefined && (missing0 = 'team_guid')) ||
        (data.team_name === undefined && (missing0 = 'team_name')) ||
        (data.accounts === undefined && (missing0 = 'accounts'))
      ) {
        validate20.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.team_guid !== undefined) {
          const _errs1 = errors;
          if (typeof data.team_guid !== 'string') {
            validate20.errors = [
              {
                instancePath: instancePath + '/team_guid',
                schemaPath: '#/properties/team_guid/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.team_name !== undefined) {
            const _errs3 = errors;
            if (typeof data.team_name !== 'string') {
              validate20.errors = [
                {
                  instancePath: instancePath + '/team_name',
                  schemaPath: '#/properties/team_name/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.role !== undefined) {
              const _errs5 = errors;
              if (typeof data.role !== 'string') {
                validate20.errors = [
                  {
                    instancePath: instancePath + '/role',
                    schemaPath: '#/properties/role/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.accounts !== undefined) {
                let data3 = data.accounts;
                const _errs7 = errors;
                if (errors === _errs7) {
                  if (Array.isArray(data3)) {
                    var valid1 = true;
                    const len0 = data3.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                      let data4 = data3[i0];
                      const _errs9 = errors;
                      const _errs10 = errors;
                      if (errors === _errs10) {
                        if (
                          data4 &&
                          typeof data4 == 'object' &&
                          !Array.isArray(data4)
                        ) {
                          let missing1;
                          if (
                            (data4.account_guid === undefined &&
                              (missing1 = 'account_guid')) ||
                            (data4.email_address === undefined &&
                              (missing1 = 'email_address'))
                          ) {
                            validate20.errors = [
                              {
                                instancePath: instancePath + '/accounts/' + i0,
                                schemaPath: 'AccountData.json/required',
                                keyword: 'required',
                                params: { missingProperty: missing1 },
                                message:
                                  "must have required property '" +
                                  missing1 +
                                  "'",
                              },
                            ];
                            return false;
                          } else {
                            if (data4.account_guid !== undefined) {
                              const _errs12 = errors;
                              if (typeof data4.account_guid !== 'string') {
                                validate20.errors = [
                                  {
                                    instancePath:
                                      instancePath +
                                      '/accounts/' +
                                      i0 +
                                      '/account_guid',
                                    schemaPath:
                                      'AccountData.json/properties/account_guid/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  },
                                ];
                                return false;
                              }
                              var valid3 = _errs12 === errors;
                            } else {
                              var valid3 = true;
                            }
                            if (valid3) {
                              if (data4.first_name !== undefined) {
                                let data6 = data4.first_name;
                                const _errs14 = errors;
                                if (
                                  typeof data6 !== 'string' &&
                                  data6 !== null
                                ) {
                                  validate20.errors = [
                                    {
                                      instancePath:
                                        instancePath +
                                        '/accounts/' +
                                        i0 +
                                        '/first_name',
                                      schemaPath:
                                        'AccountData.json/properties/first_name/type',
                                      keyword: 'type',
                                      params: {
                                        type: schema38.properties.first_name
                                          .type,
                                      },
                                      message: 'must be string,null',
                                    },
                                  ];
                                  return false;
                                }
                                var valid3 = _errs14 === errors;
                              } else {
                                var valid3 = true;
                              }
                              if (valid3) {
                                if (data4.last_name !== undefined) {
                                  let data7 = data4.last_name;
                                  const _errs16 = errors;
                                  if (
                                    typeof data7 !== 'string' &&
                                    data7 !== null
                                  ) {
                                    validate20.errors = [
                                      {
                                        instancePath:
                                          instancePath +
                                          '/accounts/' +
                                          i0 +
                                          '/last_name',
                                        schemaPath:
                                          'AccountData.json/properties/last_name/type',
                                        keyword: 'type',
                                        params: {
                                          type: schema38.properties.last_name
                                            .type,
                                        },
                                        message: 'must be string,null',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid3 = _errs16 === errors;
                                } else {
                                  var valid3 = true;
                                }
                                if (valid3) {
                                  if (data4.email_address !== undefined) {
                                    const _errs18 = errors;
                                    if (
                                      typeof data4.email_address !== 'string'
                                    ) {
                                      validate20.errors = [
                                        {
                                          instancePath:
                                            instancePath +
                                            '/accounts/' +
                                            i0 +
                                            '/email_address',
                                          schemaPath:
                                            'AccountData.json/properties/email_address/type',
                                          keyword: 'type',
                                          params: { type: 'string' },
                                          message: 'must be string',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid3 = _errs18 === errors;
                                  } else {
                                    var valid3 = true;
                                  }
                                  if (valid3) {
                                    if (data4.role !== undefined) {
                                      const _errs20 = errors;
                                      if (typeof data4.role !== 'string') {
                                        validate20.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/accounts/' +
                                              i0 +
                                              '/role',
                                            schemaPath:
                                              'AccountData.json/properties/role/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid3 = _errs20 === errors;
                                    } else {
                                      var valid3 = true;
                                    }
                                  }
                                }
                              }
                            }
                          }
                        } else {
                          validate20.errors = [
                            {
                              instancePath: instancePath + '/accounts/' + i0,
                              schemaPath: 'AccountData.json/type',
                              keyword: 'type',
                              params: { type: 'object' },
                              message: 'must be object',
                            },
                          ];
                          return false;
                        }
                      }
                      var valid1 = _errs9 === errors;
                      if (!valid1) {
                        break;
                      }
                    }
                  } else {
                    validate20.errors = [
                      {
                        instancePath: instancePath + '/accounts',
                        schemaPath: '#/properties/accounts/type',
                        keyword: 'type',
                        params: { type: 'array' },
                        message: 'must be array',
                      },
                    ];
                    return false;
                  }
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate20.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate20.errors = vErrors;
  return errors === 0;
}
function validate19(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="TeamAccountsData.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (data.team_accounts === undefined && (missing0 = 'team_accounts')) {
        validate19.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.team_accounts !== undefined) {
          let data0 = data.team_accounts;
          const _errs1 = errors;
          if (errors === _errs1) {
            if (Array.isArray(data0)) {
              var valid1 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                const _errs3 = errors;
                if (
                  !validate20(data0[i0], {
                    instancePath: instancePath + '/team_accounts/' + i0,
                    parentData: data0,
                    parentDataProperty: i0,
                    rootData,
                  })
                ) {
                  vErrors =
                    vErrors === null
                      ? validate20.errors
                      : vErrors.concat(validate20.errors);
                  errors = vErrors.length;
                }
                var valid1 = _errs3 === errors;
                if (!valid1) {
                  break;
                }
              }
            } else {
              validate19.errors = [
                {
                  instancePath: instancePath + '/team_accounts',
                  schemaPath: '#/properties/team_accounts/type',
                  keyword: 'type',
                  params: { type: 'array' },
                  message: 'must be array',
                },
              ];
              return false;
            }
          }
        }
      }
    } else {
      validate19.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate19.errors = vErrors;
  return errors === 0;
}
function validate10(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="APIDashboard.json" */ let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == 'object' && !Array.isArray(data))) {
    validate10.errors = [
      {
        instancePath,
        schemaPath: '#/type',
        keyword: 'type',
        params: { type: 'object' },
        message: 'must be object',
      },
    ];
    return false;
  }
  const _errs1 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs2 = errors;
  const _errs3 = errors;
  if (errors === _errs3) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.account_id === undefined && (missing0 = 'account_id')) ||
        (data.last_day === undefined && (missing0 = 'last_day')) ||
        (data.range === undefined && (missing0 = 'range')) ||
        (data.total === undefined && (missing0 = 'total'))
      ) {
        const err0 = {
          instancePath,
          schemaPath: 'APIUsageData.json/required',
          keyword: 'required',
          params: { missingProperty: missing0 },
          message: "must have required property '" + missing0 + "'",
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        if (data.account_id !== undefined) {
          const _errs5 = errors;
          if (typeof data.account_id !== 'string') {
            const err1 = {
              instancePath: instancePath + '/account_id',
              schemaPath: 'APIUsageData.json/properties/account_id/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
            };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
          var valid2 = _errs5 === errors;
        } else {
          var valid2 = true;
        }
        if (valid2) {
          if (data.items !== undefined) {
            let data1 = data.items;
            const _errs7 = errors;
            if (errors === _errs7) {
              if (Array.isArray(data1)) {
                var valid3 = true;
                const len0 = data1.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  let data2 = data1[i0];
                  const _errs9 = errors;
                  if (
                    data2 &&
                    typeof data2 == 'object' &&
                    !Array.isArray(data2)
                  ) {
                    let missing1;
                    if (
                      (data2.count === undefined && (missing1 = 'count')) ||
                      (data2.date === undefined && (missing1 = 'date'))
                    ) {
                      const err2 = {
                        instancePath: instancePath + '/items/' + i0,
                        schemaPath:
                          'APIUsageData.json/properties/items/items/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message:
                          "must have required property '" + missing1 + "'",
                      };
                      if (vErrors === null) {
                        vErrors = [err2];
                      } else {
                        vErrors.push(err2);
                      }
                      errors++;
                    } else {
                      if (data2.count !== undefined) {
                        let data3 = data2.count;
                        const _errs10 = errors;
                        if (!(typeof data3 == 'number' && isFinite(data3))) {
                          const err3 = {
                            instancePath:
                              instancePath + '/items/' + i0 + '/count',
                            schemaPath:
                              'APIUsageData.json/properties/items/items/properties/count/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                          };
                          if (vErrors === null) {
                            vErrors = [err3];
                          } else {
                            vErrors.push(err3);
                          }
                          errors++;
                        }
                        var valid4 = _errs10 === errors;
                      } else {
                        var valid4 = true;
                      }
                      if (valid4) {
                        if (data2.date !== undefined) {
                          const _errs12 = errors;
                          if (typeof data2.date !== 'string') {
                            const err4 = {
                              instancePath:
                                instancePath + '/items/' + i0 + '/date',
                              schemaPath:
                                'APIUsageData.json/properties/items/items/properties/date/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            };
                            if (vErrors === null) {
                              vErrors = [err4];
                            } else {
                              vErrors.push(err4);
                            }
                            errors++;
                          }
                          var valid4 = _errs12 === errors;
                        } else {
                          var valid4 = true;
                        }
                      }
                    }
                  }
                  var valid3 = _errs9 === errors;
                  if (!valid3) {
                    break;
                  }
                }
              } else {
                const err5 = {
                  instancePath: instancePath + '/items',
                  schemaPath: 'APIUsageData.json/properties/items/type',
                  keyword: 'type',
                  params: { type: 'array' },
                  message: 'must be array',
                };
                if (vErrors === null) {
                  vErrors = [err5];
                } else {
                  vErrors.push(err5);
                }
                errors++;
              }
            }
            var valid2 = _errs7 === errors;
          } else {
            var valid2 = true;
          }
          if (valid2) {
            if (data.last_day !== undefined) {
              let data5 = data.last_day;
              const _errs14 = errors;
              if (!(typeof data5 == 'number' && isFinite(data5))) {
                const err6 = {
                  instancePath: instancePath + '/last_day',
                  schemaPath: 'APIUsageData.json/properties/last_day/type',
                  keyword: 'type',
                  params: { type: 'number' },
                  message: 'must be number',
                };
                if (vErrors === null) {
                  vErrors = [err6];
                } else {
                  vErrors.push(err6);
                }
                errors++;
              }
              var valid2 = _errs14 === errors;
            } else {
              var valid2 = true;
            }
            if (valid2) {
              if (data.range !== undefined) {
                const _errs16 = errors;
                if (typeof data.range !== 'string') {
                  const err7 = {
                    instancePath: instancePath + '/range',
                    schemaPath: 'APIUsageData.json/properties/range/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  };
                  if (vErrors === null) {
                    vErrors = [err7];
                  } else {
                    vErrors.push(err7);
                  }
                  errors++;
                }
                var valid2 = _errs16 === errors;
              } else {
                var valid2 = true;
              }
              if (valid2) {
                if (data.total !== undefined) {
                  let data7 = data.total;
                  const _errs18 = errors;
                  if (!(typeof data7 == 'number' && isFinite(data7))) {
                    const err8 = {
                      instancePath: instancePath + '/total',
                      schemaPath: 'APIUsageData.json/properties/total/type',
                      keyword: 'type',
                      params: { type: 'number' },
                      message: 'must be number',
                    };
                    if (vErrors === null) {
                      vErrors = [err8];
                    } else {
                      vErrors.push(err8);
                    }
                    errors++;
                  }
                  var valid2 = _errs18 === errors;
                } else {
                  var valid2 = true;
                }
              }
            }
          }
        }
      }
    } else {
      const err9 = {
        instancePath,
        schemaPath: 'APIUsageData.json/type',
        keyword: 'type',
        params: { type: 'object' },
        message: 'must be object',
      };
      if (vErrors === null) {
        vErrors = [err9];
      } else {
        vErrors.push(err9);
      }
      errors++;
    }
  }
  var _valid0 = _errs2 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs20 = errors;
  const _errs21 = errors;
  if (errors === _errs21) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing2;
      if (
        (data.x === undefined && (missing2 = 'x')) ||
        (data.y === undefined && (missing2 = 'y'))
      ) {
        const err10 = {
          instancePath,
          schemaPath: 'SignatureRequestUsageData.json/required',
          keyword: 'required',
          params: { missingProperty: missing2 },
          message: "must have required property '" + missing2 + "'",
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      } else {
        if (data.x !== undefined) {
          let data8 = data.x;
          const _errs23 = errors;
          if (errors === _errs23) {
            if (Array.isArray(data8)) {
              var valid7 = true;
              const len1 = data8.length;
              for (let i1 = 0; i1 < len1; i1++) {
                const _errs25 = errors;
                if (typeof data8[i1] !== 'string') {
                  const err11 = {
                    instancePath: instancePath + '/x/' + i1,
                    schemaPath:
                      'SignatureRequestUsageData.json/properties/x/items/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  };
                  if (vErrors === null) {
                    vErrors = [err11];
                  } else {
                    vErrors.push(err11);
                  }
                  errors++;
                }
                var valid7 = _errs25 === errors;
                if (!valid7) {
                  break;
                }
              }
            } else {
              const err12 = {
                instancePath: instancePath + '/x',
                schemaPath: 'SignatureRequestUsageData.json/properties/x/type',
                keyword: 'type',
                params: { type: 'array' },
                message: 'must be array',
              };
              if (vErrors === null) {
                vErrors = [err12];
              } else {
                vErrors.push(err12);
              }
              errors++;
            }
          }
          var valid6 = _errs23 === errors;
        } else {
          var valid6 = true;
        }
        if (valid6) {
          if (data.y !== undefined) {
            let data10 = data.y;
            const _errs27 = errors;
            if (errors === _errs27) {
              if (Array.isArray(data10)) {
                var valid8 = true;
                const len2 = data10.length;
                for (let i2 = 0; i2 < len2; i2++) {
                  let data11 = data10[i2];
                  const _errs29 = errors;
                  if (!(typeof data11 == 'number' && isFinite(data11))) {
                    const err13 = {
                      instancePath: instancePath + '/y/' + i2,
                      schemaPath:
                        'SignatureRequestUsageData.json/properties/y/items/type',
                      keyword: 'type',
                      params: { type: 'number' },
                      message: 'must be number',
                    };
                    if (vErrors === null) {
                      vErrors = [err13];
                    } else {
                      vErrors.push(err13);
                    }
                    errors++;
                  }
                  var valid8 = _errs29 === errors;
                  if (!valid8) {
                    break;
                  }
                }
              } else {
                const err14 = {
                  instancePath: instancePath + '/y',
                  schemaPath:
                    'SignatureRequestUsageData.json/properties/y/type',
                  keyword: 'type',
                  params: { type: 'array' },
                  message: 'must be array',
                };
                if (vErrors === null) {
                  vErrors = [err14];
                } else {
                  vErrors.push(err14);
                }
                errors++;
              }
            }
            var valid6 = _errs27 === errors;
          } else {
            var valid6 = true;
          }
          if (valid6) {
            if (data.client_ids !== undefined) {
              let data12 = data.client_ids;
              const _errs31 = errors;
              if (errors === _errs31) {
                if (Array.isArray(data12)) {
                  var valid9 = true;
                  const len3 = data12.length;
                  for (let i3 = 0; i3 < len3; i3++) {
                    const _errs33 = errors;
                    if (typeof data12[i3] !== 'string') {
                      const err15 = {
                        instancePath: instancePath + '/client_ids/' + i3,
                        schemaPath:
                          'SignatureRequestUsageData.json/properties/client_ids/items/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      };
                      if (vErrors === null) {
                        vErrors = [err15];
                      } else {
                        vErrors.push(err15);
                      }
                      errors++;
                    }
                    var valid9 = _errs33 === errors;
                    if (!valid9) {
                      break;
                    }
                  }
                } else {
                  const err16 = {
                    instancePath: instancePath + '/client_ids',
                    schemaPath:
                      'SignatureRequestUsageData.json/properties/client_ids/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                  };
                  if (vErrors === null) {
                    vErrors = [err16];
                  } else {
                    vErrors.push(err16);
                  }
                  errors++;
                }
              }
              var valid6 = _errs31 === errors;
            } else {
              var valid6 = true;
            }
          }
        }
      }
    } else {
      const err17 = {
        instancePath,
        schemaPath: 'SignatureRequestUsageData.json/type',
        keyword: 'type',
        params: { type: 'object' },
        message: 'must be object',
      };
      if (vErrors === null) {
        vErrors = [err17];
      } else {
        vErrors.push(err17);
      }
      errors++;
    }
  }
  var _valid0 = _errs20 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
    const _errs35 = errors;
    if (
      !validate11(data, {
        instancePath,
        parentData,
        parentDataProperty,
        rootData,
      })
    ) {
      vErrors =
        vErrors === null
          ? validate11.errors
          : vErrors.concat(validate11.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs35 === errors;
    if (_valid0 && valid0) {
      valid0 = false;
      passing0 = [passing0, 2];
    } else {
      if (_valid0) {
        valid0 = true;
        passing0 = 2;
      }
      const _errs36 = errors;
      const _errs37 = errors;
      if (errors === _errs37) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
          let missing3;
          if (
            (data.account_id === undefined && (missing3 = 'account_id')) ||
            (data.last_day === undefined && (missing3 = 'last_day')) ||
            (data.range === undefined && (missing3 = 'range')) ||
            (data.total === undefined && (missing3 = 'total'))
          ) {
            const err18 = {
              instancePath,
              schemaPath: 'APIUsageData.json/required',
              keyword: 'required',
              params: { missingProperty: missing3 },
              message: "must have required property '" + missing3 + "'",
            };
            if (vErrors === null) {
              vErrors = [err18];
            } else {
              vErrors.push(err18);
            }
            errors++;
          } else {
            if (data.account_id !== undefined) {
              const _errs39 = errors;
              if (typeof data.account_id !== 'string') {
                const err19 = {
                  instancePath: instancePath + '/account_id',
                  schemaPath: 'APIUsageData.json/properties/account_id/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                };
                if (vErrors === null) {
                  vErrors = [err19];
                } else {
                  vErrors.push(err19);
                }
                errors++;
              }
              var valid11 = _errs39 === errors;
            } else {
              var valid11 = true;
            }
            if (valid11) {
              if (data.items !== undefined) {
                let data15 = data.items;
                const _errs41 = errors;
                if (errors === _errs41) {
                  if (Array.isArray(data15)) {
                    var valid12 = true;
                    const len4 = data15.length;
                    for (let i4 = 0; i4 < len4; i4++) {
                      let data16 = data15[i4];
                      const _errs43 = errors;
                      if (
                        data16 &&
                        typeof data16 == 'object' &&
                        !Array.isArray(data16)
                      ) {
                        let missing4;
                        if (
                          (data16.count === undefined &&
                            (missing4 = 'count')) ||
                          (data16.date === undefined && (missing4 = 'date'))
                        ) {
                          const err20 = {
                            instancePath: instancePath + '/items/' + i4,
                            schemaPath:
                              'APIUsageData.json/properties/items/items/required',
                            keyword: 'required',
                            params: { missingProperty: missing4 },
                            message:
                              "must have required property '" + missing4 + "'",
                          };
                          if (vErrors === null) {
                            vErrors = [err20];
                          } else {
                            vErrors.push(err20);
                          }
                          errors++;
                        } else {
                          if (data16.count !== undefined) {
                            let data17 = data16.count;
                            const _errs44 = errors;
                            if (
                              !(typeof data17 == 'number' && isFinite(data17))
                            ) {
                              const err21 = {
                                instancePath:
                                  instancePath + '/items/' + i4 + '/count',
                                schemaPath:
                                  'APIUsageData.json/properties/items/items/properties/count/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number',
                              };
                              if (vErrors === null) {
                                vErrors = [err21];
                              } else {
                                vErrors.push(err21);
                              }
                              errors++;
                            }
                            var valid13 = _errs44 === errors;
                          } else {
                            var valid13 = true;
                          }
                          if (valid13) {
                            if (data16.date !== undefined) {
                              const _errs46 = errors;
                              if (typeof data16.date !== 'string') {
                                const err22 = {
                                  instancePath:
                                    instancePath + '/items/' + i4 + '/date',
                                  schemaPath:
                                    'APIUsageData.json/properties/items/items/properties/date/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                };
                                if (vErrors === null) {
                                  vErrors = [err22];
                                } else {
                                  vErrors.push(err22);
                                }
                                errors++;
                              }
                              var valid13 = _errs46 === errors;
                            } else {
                              var valid13 = true;
                            }
                          }
                        }
                      }
                      var valid12 = _errs43 === errors;
                      if (!valid12) {
                        break;
                      }
                    }
                  } else {
                    const err23 = {
                      instancePath: instancePath + '/items',
                      schemaPath: 'APIUsageData.json/properties/items/type',
                      keyword: 'type',
                      params: { type: 'array' },
                      message: 'must be array',
                    };
                    if (vErrors === null) {
                      vErrors = [err23];
                    } else {
                      vErrors.push(err23);
                    }
                    errors++;
                  }
                }
                var valid11 = _errs41 === errors;
              } else {
                var valid11 = true;
              }
              if (valid11) {
                if (data.last_day !== undefined) {
                  let data19 = data.last_day;
                  const _errs48 = errors;
                  if (!(typeof data19 == 'number' && isFinite(data19))) {
                    const err24 = {
                      instancePath: instancePath + '/last_day',
                      schemaPath: 'APIUsageData.json/properties/last_day/type',
                      keyword: 'type',
                      params: { type: 'number' },
                      message: 'must be number',
                    };
                    if (vErrors === null) {
                      vErrors = [err24];
                    } else {
                      vErrors.push(err24);
                    }
                    errors++;
                  }
                  var valid11 = _errs48 === errors;
                } else {
                  var valid11 = true;
                }
                if (valid11) {
                  if (data.range !== undefined) {
                    const _errs50 = errors;
                    if (typeof data.range !== 'string') {
                      const err25 = {
                        instancePath: instancePath + '/range',
                        schemaPath: 'APIUsageData.json/properties/range/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      };
                      if (vErrors === null) {
                        vErrors = [err25];
                      } else {
                        vErrors.push(err25);
                      }
                      errors++;
                    }
                    var valid11 = _errs50 === errors;
                  } else {
                    var valid11 = true;
                  }
                  if (valid11) {
                    if (data.total !== undefined) {
                      let data21 = data.total;
                      const _errs52 = errors;
                      if (!(typeof data21 == 'number' && isFinite(data21))) {
                        const err26 = {
                          instancePath: instancePath + '/total',
                          schemaPath: 'APIUsageData.json/properties/total/type',
                          keyword: 'type',
                          params: { type: 'number' },
                          message: 'must be number',
                        };
                        if (vErrors === null) {
                          vErrors = [err26];
                        } else {
                          vErrors.push(err26);
                        }
                        errors++;
                      }
                      var valid11 = _errs52 === errors;
                    } else {
                      var valid11 = true;
                    }
                  }
                }
              }
            }
          }
        } else {
          const err27 = {
            instancePath,
            schemaPath: 'APIUsageData.json/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
          };
          if (vErrors === null) {
            vErrors = [err27];
          } else {
            vErrors.push(err27);
          }
          errors++;
        }
      }
      var _valid0 = _errs36 === errors;
      if (_valid0 && valid0) {
        valid0 = false;
        passing0 = [passing0, 3];
      } else {
        if (_valid0) {
          valid0 = true;
          passing0 = 3;
        }
        const _errs54 = errors;
        const _errs55 = errors;
        if (errors === _errs55) {
          if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing5;
            if (
              data.timezone_info === undefined &&
              (missing5 = 'timezone_info')
            ) {
              const err28 = {
                instancePath,
                schemaPath: 'APIAccountData.json/required',
                keyword: 'required',
                params: { missingProperty: missing5 },
                message: "must have required property '" + missing5 + "'",
              };
              if (vErrors === null) {
                vErrors = [err28];
              } else {
                vErrors.push(err28);
              }
              errors++;
            } else {
              if (data.account_id !== undefined) {
                const _errs57 = errors;
                if (typeof data.account_id !== 'string') {
                  const err29 = {
                    instancePath: instancePath + '/account_id',
                    schemaPath:
                      'APIAccountData.json/properties/account_id/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  };
                  if (vErrors === null) {
                    vErrors = [err29];
                  } else {
                    vErrors.push(err29);
                  }
                  errors++;
                }
                var valid15 = _errs57 === errors;
              } else {
                var valid15 = true;
              }
              if (valid15) {
                if (data.emailAddress !== undefined) {
                  const _errs59 = errors;
                  if (typeof data.emailAddress !== 'string') {
                    const err30 = {
                      instancePath: instancePath + '/emailAddress',
                      schemaPath:
                        'APIAccountData.json/properties/emailAddress/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    };
                    if (vErrors === null) {
                      vErrors = [err30];
                    } else {
                      vErrors.push(err30);
                    }
                    errors++;
                  }
                  var valid15 = _errs59 === errors;
                } else {
                  var valid15 = true;
                }
                if (valid15) {
                  if (data.timezone_info !== undefined) {
                    let data24 = data.timezone_info;
                    const _errs61 = errors;
                    if (errors === _errs61) {
                      if (
                        data24 &&
                        typeof data24 == 'object' &&
                        !Array.isArray(data24)
                      ) {
                        if (data24.abbreviation !== undefined) {
                          const _errs63 = errors;
                          if (typeof data24.abbreviation !== 'string') {
                            const err31 = {
                              instancePath:
                                instancePath + '/timezone_info/abbreviation',
                              schemaPath:
                                'APIAccountData.json/properties/timezone_info/properties/abbreviation/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            };
                            if (vErrors === null) {
                              vErrors = [err31];
                            } else {
                              vErrors.push(err31);
                            }
                            errors++;
                          }
                          var valid16 = _errs63 === errors;
                        } else {
                          var valid16 = true;
                        }
                        if (valid16) {
                          if (data24.display_name !== undefined) {
                            const _errs65 = errors;
                            if (typeof data24.display_name !== 'string') {
                              const err32 = {
                                instancePath:
                                  instancePath + '/timezone_info/display_name',
                                schemaPath:
                                  'APIAccountData.json/properties/timezone_info/properties/display_name/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              };
                              if (vErrors === null) {
                                vErrors = [err32];
                              } else {
                                vErrors.push(err32);
                              }
                              errors++;
                            }
                            var valid16 = _errs65 === errors;
                          } else {
                            var valid16 = true;
                          }
                          if (valid16) {
                            if (data24.gmt_offset !== undefined) {
                              let data27 = data24.gmt_offset;
                              const _errs67 = errors;
                              if (
                                !(typeof data27 == 'number' && isFinite(data27))
                              ) {
                                const err33 = {
                                  instancePath:
                                    instancePath + '/timezone_info/gmt_offset',
                                  schemaPath:
                                    'APIAccountData.json/properties/timezone_info/properties/gmt_offset/type',
                                  keyword: 'type',
                                  params: { type: 'number' },
                                  message: 'must be number',
                                };
                                if (vErrors === null) {
                                  vErrors = [err33];
                                } else {
                                  vErrors.push(err33);
                                }
                                errors++;
                              }
                              var valid16 = _errs67 === errors;
                            } else {
                              var valid16 = true;
                            }
                            if (valid16) {
                              if (data24.has_dst !== undefined) {
                                let data28 = data24.has_dst;
                                const _errs69 = errors;
                                if (
                                  !(
                                    typeof data28 == 'number' &&
                                    isFinite(data28)
                                  )
                                ) {
                                  const err34 = {
                                    instancePath:
                                      instancePath + '/timezone_info/has_dst',
                                    schemaPath:
                                      'APIAccountData.json/properties/timezone_info/properties/has_dst/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number',
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err34];
                                  } else {
                                    vErrors.push(err34);
                                  }
                                  errors++;
                                }
                                var valid16 = _errs69 === errors;
                              } else {
                                var valid16 = true;
                              }
                              if (valid16) {
                                if (data24.matching_identifier !== undefined) {
                                  const _errs71 = errors;
                                  if (
                                    typeof data24.matching_identifier !==
                                    'string'
                                  ) {
                                    const err35 = {
                                      instancePath:
                                        instancePath +
                                        '/timezone_info/matching_identifier',
                                      schemaPath:
                                        'APIAccountData.json/properties/timezone_info/properties/matching_identifier/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err35];
                                    } else {
                                      vErrors.push(err35);
                                    }
                                    errors++;
                                  }
                                  var valid16 = _errs71 === errors;
                                } else {
                                  var valid16 = true;
                                }
                              }
                            }
                          }
                        }
                      } else {
                        const err36 = {
                          instancePath: instancePath + '/timezone_info',
                          schemaPath:
                            'APIAccountData.json/properties/timezone_info/type',
                          keyword: 'type',
                          params: { type: 'object' },
                          message: 'must be object',
                        };
                        if (vErrors === null) {
                          vErrors = [err36];
                        } else {
                          vErrors.push(err36);
                        }
                        errors++;
                      }
                    }
                    var valid15 = _errs61 === errors;
                  } else {
                    var valid15 = true;
                  }
                  if (valid15) {
                    if (data.billing !== undefined) {
                      let data30 = data.billing;
                      const _errs73 = errors;
                      if (errors === _errs73) {
                        if (
                          data30 &&
                          typeof data30 == 'object' &&
                          !Array.isArray(data30)
                        ) {
                          if (data30.next_refresh_date !== undefined) {
                            let data31 = data30.next_refresh_date;
                            const _errs75 = errors;
                            if (typeof data31 !== 'string' && data31 !== null) {
                              const err37 = {
                                instancePath:
                                  instancePath + '/billing/next_refresh_date',
                                schemaPath:
                                  'APIAccountData.json/properties/billing/properties/next_refresh_date/type',
                                keyword: 'type',
                                params: {
                                  type: schema17.properties.billing.properties
                                    .next_refresh_date.type,
                                },
                                message: 'must be string,null',
                              };
                              if (vErrors === null) {
                                vErrors = [err37];
                              } else {
                                vErrors.push(err37);
                              }
                              errors++;
                            }
                            var valid17 = _errs75 === errors;
                          } else {
                            var valid17 = true;
                          }
                          if (valid17) {
                            if (data30.next_billing_date !== undefined) {
                              let data32 = data30.next_billing_date;
                              const _errs77 = errors;
                              if (
                                typeof data32 !== 'string' &&
                                data32 !== null
                              ) {
                                const err38 = {
                                  instancePath:
                                    instancePath + '/billing/next_billing_date',
                                  schemaPath:
                                    'APIAccountData.json/properties/billing/properties/next_billing_date/type',
                                  keyword: 'type',
                                  params: {
                                    type: schema17.properties.billing.properties
                                      .next_billing_date.type,
                                  },
                                  message: 'must be string,null',
                                };
                                if (vErrors === null) {
                                  vErrors = [err38];
                                } else {
                                  vErrors.push(err38);
                                }
                                errors++;
                              }
                              var valid17 = _errs77 === errors;
                            } else {
                              var valid17 = true;
                            }
                            if (valid17) {
                              if (data30.plan_name !== undefined) {
                                const _errs79 = errors;
                                if (typeof data30.plan_name !== 'string') {
                                  const err39 = {
                                    instancePath:
                                      instancePath + '/billing/plan_name',
                                    schemaPath:
                                      'APIAccountData.json/properties/billing/properties/plan_name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err39];
                                  } else {
                                    vErrors.push(err39);
                                  }
                                  errors++;
                                }
                                var valid17 = _errs79 === errors;
                              } else {
                                var valid17 = true;
                              }
                            }
                          }
                        } else {
                          const err40 = {
                            instancePath: instancePath + '/billing',
                            schemaPath:
                              'APIAccountData.json/properties/billing/type',
                            keyword: 'type',
                            params: { type: 'object' },
                            message: 'must be object',
                          };
                          if (vErrors === null) {
                            vErrors = [err40];
                          } else {
                            vErrors.push(err40);
                          }
                          errors++;
                        }
                      }
                      var valid15 = _errs73 === errors;
                    } else {
                      var valid15 = true;
                    }
                    if (valid15) {
                      if (data.quotas !== undefined) {
                        let data34 = data.quotas;
                        const _errs81 = errors;
                        if (errors === _errs81) {
                          if (
                            data34 &&
                            typeof data34 == 'object' &&
                            !Array.isArray(data34)
                          ) {
                            if (data34.templates_left !== undefined) {
                              let data35 = data34.templates_left;
                              const _errs83 = errors;
                              if (
                                !(
                                  typeof data35 == 'number' && isFinite(data35)
                                ) &&
                                data35 !== null
                              ) {
                                const err41 = {
                                  instancePath:
                                    instancePath + '/quotas/templates_left',
                                  schemaPath:
                                    'APIAccountData.json/properties/quotas/properties/templates_left/type',
                                  keyword: 'type',
                                  params: {
                                    type: schema17.properties.quotas.properties
                                      .templates_left.type,
                                  },
                                  message: 'must be number,null',
                                };
                                if (vErrors === null) {
                                  vErrors = [err41];
                                } else {
                                  vErrors.push(err41);
                                }
                                errors++;
                              }
                              var valid18 = _errs83 === errors;
                            } else {
                              var valid18 = true;
                            }
                            if (valid18) {
                              if (data34.documents_left !== undefined) {
                                let data36 = data34.documents_left;
                                const _errs85 = errors;
                                if (
                                  !(
                                    typeof data36 == 'number' &&
                                    isFinite(data36)
                                  ) &&
                                  data36 !== null
                                ) {
                                  const err42 = {
                                    instancePath:
                                      instancePath + '/quotas/documents_left',
                                    schemaPath:
                                      'APIAccountData.json/properties/quotas/properties/documents_left/type',
                                    keyword: 'type',
                                    params: {
                                      type: schema17.properties.quotas
                                        .properties.documents_left.type,
                                    },
                                    message: 'must be number,null',
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err42];
                                  } else {
                                    vErrors.push(err42);
                                  }
                                  errors++;
                                }
                                var valid18 = _errs85 === errors;
                              } else {
                                var valid18 = true;
                              }
                              if (valid18) {
                                if (
                                  data34.api_signature_requests_left !==
                                  undefined
                                ) {
                                  let data37 =
                                    data34.api_signature_requests_left;
                                  const _errs87 = errors;
                                  if (
                                    !(
                                      typeof data37 == 'number' &&
                                      isFinite(data37)
                                    ) &&
                                    data37 !== null
                                  ) {
                                    const err43 = {
                                      instancePath:
                                        instancePath +
                                        '/quotas/api_signature_requests_left',
                                      schemaPath:
                                        'APIAccountData.json/properties/quotas/properties/api_signature_requests_left/type',
                                      keyword: 'type',
                                      params: {
                                        type: schema17.properties.quotas
                                          .properties
                                          .api_signature_requests_left.type,
                                      },
                                      message: 'must be number,null',
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err43];
                                    } else {
                                      vErrors.push(err43);
                                    }
                                    errors++;
                                  }
                                  var valid18 = _errs87 === errors;
                                } else {
                                  var valid18 = true;
                                }
                                if (valid18) {
                                  if (
                                    data34.all_signature_requests_left !==
                                    undefined
                                  ) {
                                    let data38 =
                                      data34.all_signature_requests_left;
                                    const _errs89 = errors;
                                    if (
                                      !(
                                        typeof data38 == 'number' &&
                                        isFinite(data38)
                                      ) &&
                                      data38 !== null
                                    ) {
                                      const err44 = {
                                        instancePath:
                                          instancePath +
                                          '/quotas/all_signature_requests_left',
                                        schemaPath:
                                          'APIAccountData.json/properties/quotas/properties/all_signature_requests_left/type',
                                        keyword: 'type',
                                        params: {
                                          type: schema17.properties.quotas
                                            .properties
                                            .all_signature_requests_left.type,
                                        },
                                        message: 'must be number,null',
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err44];
                                      } else {
                                        vErrors.push(err44);
                                      }
                                      errors++;
                                    }
                                    var valid18 = _errs89 === errors;
                                  } else {
                                    var valid18 = true;
                                  }
                                  if (valid18) {
                                    if (
                                      data34.all_signature_requests_total !==
                                      undefined
                                    ) {
                                      let data39 =
                                        data34.all_signature_requests_total;
                                      const _errs91 = errors;
                                      if (
                                        !(
                                          typeof data39 == 'number' &&
                                          isFinite(data39)
                                        ) &&
                                        data39 !== null
                                      ) {
                                        const err45 = {
                                          instancePath:
                                            instancePath +
                                            '/quotas/all_signature_requests_total',
                                          schemaPath:
                                            'APIAccountData.json/properties/quotas/properties/all_signature_requests_total/type',
                                          keyword: 'type',
                                          params: {
                                            type: schema17.properties.quotas
                                              .properties
                                              .all_signature_requests_total
                                              .type,
                                          },
                                          message: 'must be number,null',
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err45];
                                        } else {
                                          vErrors.push(err45);
                                        }
                                        errors++;
                                      }
                                      var valid18 = _errs91 === errors;
                                    } else {
                                      var valid18 = true;
                                    }
                                    if (valid18) {
                                      if (
                                        data34.templates_total !== undefined
                                      ) {
                                        let data40 = data34.templates_total;
                                        const _errs93 = errors;
                                        if (
                                          !(
                                            typeof data40 == 'number' &&
                                            isFinite(data40)
                                          ) &&
                                          data40 !== null
                                        ) {
                                          const err46 = {
                                            instancePath:
                                              instancePath +
                                              '/quotas/templates_total',
                                            schemaPath:
                                              'APIAccountData.json/properties/quotas/properties/templates_total/type',
                                            keyword: 'type',
                                            params: {
                                              type: schema17.properties.quotas
                                                .properties.templates_total
                                                .type,
                                            },
                                            message: 'must be number,null',
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err46];
                                          } else {
                                            vErrors.push(err46);
                                          }
                                          errors++;
                                        }
                                        var valid18 = _errs93 === errors;
                                      } else {
                                        var valid18 = true;
                                      }
                                      if (valid18) {
                                        if (
                                          data34.sms_verifications_left !==
                                          undefined
                                        ) {
                                          let data41 =
                                            data34.sms_verifications_left;
                                          const _errs95 = errors;
                                          if (
                                            !(
                                              typeof data41 == 'number' &&
                                              isFinite(data41)
                                            ) &&
                                            data41 !== null
                                          ) {
                                            const err47 = {
                                              instancePath:
                                                instancePath +
                                                '/quotas/sms_verifications_left',
                                              schemaPath:
                                                'APIAccountData.json/properties/quotas/properties/sms_verifications_left/type',
                                              keyword: 'type',
                                              params: {
                                                type: schema17.properties.quotas
                                                  .properties
                                                  .sms_verifications_left.type,
                                              },
                                              message: 'must be number,null',
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err47];
                                            } else {
                                              vErrors.push(err47);
                                            }
                                            errors++;
                                          }
                                          var valid18 = _errs95 === errors;
                                        } else {
                                          var valid18 = true;
                                        }
                                        if (valid18) {
                                          if (
                                            data34.sms_verifications_total !==
                                            undefined
                                          ) {
                                            let data42 =
                                              data34.sms_verifications_total;
                                            const _errs97 = errors;
                                            if (
                                              !(
                                                typeof data42 == 'number' &&
                                                isFinite(data42)
                                              ) &&
                                              data42 !== null
                                            ) {
                                              const err48 = {
                                                instancePath:
                                                  instancePath +
                                                  '/quotas/sms_verifications_total',
                                                schemaPath:
                                                  'APIAccountData.json/properties/quotas/properties/sms_verifications_total/type',
                                                keyword: 'type',
                                                params: {
                                                  type: schema17.properties
                                                    .quotas.properties
                                                    .sms_verifications_total
                                                    .type,
                                                },
                                                message: 'must be number,null',
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err48];
                                              } else {
                                                vErrors.push(err48);
                                              }
                                              errors++;
                                            }
                                            var valid18 = _errs97 === errors;
                                          } else {
                                            var valid18 = true;
                                          }
                                          if (valid18) {
                                            if (
                                              data34.api_signature_requests_used !==
                                              undefined
                                            ) {
                                              let data43 =
                                                data34.api_signature_requests_used;
                                              const _errs99 = errors;
                                              if (
                                                !(
                                                  typeof data43 == 'number' &&
                                                  isFinite(data43)
                                                ) &&
                                                data43 !== null
                                              ) {
                                                const err49 = {
                                                  instancePath:
                                                    instancePath +
                                                    '/quotas/api_signature_requests_used',
                                                  schemaPath:
                                                    'APIAccountData.json/properties/quotas/properties/api_signature_requests_used/type',
                                                  keyword: 'type',
                                                  params: {
                                                    type: schema17.properties
                                                      .quotas.properties
                                                      .api_signature_requests_used
                                                      .type,
                                                  },
                                                  message:
                                                    'must be number,null',
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err49];
                                                } else {
                                                  vErrors.push(err49);
                                                }
                                                errors++;
                                              }
                                              var valid18 = _errs99 === errors;
                                            } else {
                                              var valid18 = true;
                                            }
                                            if (valid18) {
                                              if (
                                                data34.api_signature_requests_total !==
                                                undefined
                                              ) {
                                                let data44 =
                                                  data34.api_signature_requests_total;
                                                const _errs101 = errors;
                                                if (
                                                  !(
                                                    typeof data44 == 'number' &&
                                                    isFinite(data44)
                                                  ) &&
                                                  data44 !== null
                                                ) {
                                                  const err50 = {
                                                    instancePath:
                                                      instancePath +
                                                      '/quotas/api_signature_requests_total',
                                                    schemaPath:
                                                      'APIAccountData.json/properties/quotas/properties/api_signature_requests_total/type',
                                                    keyword: 'type',
                                                    params: {
                                                      type: schema17.properties
                                                        .quotas.properties
                                                        .api_signature_requests_total
                                                        .type,
                                                    },
                                                    message:
                                                      'must be number,null',
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err50];
                                                  } else {
                                                    vErrors.push(err50);
                                                  }
                                                  errors++;
                                                }
                                                var valid18 =
                                                  _errs101 === errors;
                                              } else {
                                                var valid18 = true;
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          } else {
                            const err51 = {
                              instancePath: instancePath + '/quotas',
                              schemaPath:
                                'APIAccountData.json/properties/quotas/type',
                              keyword: 'type',
                              params: { type: 'object' },
                              message: 'must be object',
                            };
                            if (vErrors === null) {
                              vErrors = [err51];
                            } else {
                              vErrors.push(err51);
                            }
                            errors++;
                          }
                        }
                        var valid15 = _errs81 === errors;
                      } else {
                        var valid15 = true;
                      }
                    }
                  }
                }
              }
            }
          } else {
            const err52 = {
              instancePath,
              schemaPath: 'APIAccountData.json/type',
              keyword: 'type',
              params: { type: 'object' },
              message: 'must be object',
            };
            if (vErrors === null) {
              vErrors = [err52];
            } else {
              vErrors.push(err52);
            }
            errors++;
          }
        }
        var _valid0 = _errs54 === errors;
        if (_valid0 && valid0) {
          valid0 = false;
          passing0 = [passing0, 4];
        } else {
          if (_valid0) {
            valid0 = true;
            passing0 = 4;
          }
          const _errs103 = errors;
          const _errs104 = errors;
          if (errors === _errs104) {
            if (data && typeof data == 'object' && !Array.isArray(data)) {
              let missing6;
              if (
                (data.count === undefined && (missing6 = 'count')) ||
                (data.page_size === undefined && (missing6 = 'page_size'))
              ) {
                const err53 = {
                  instancePath,
                  schemaPath: 'APICallbacksData.json/required',
                  keyword: 'required',
                  params: { missingProperty: missing6 },
                  message: "must have required property '" + missing6 + "'",
                };
                if (vErrors === null) {
                  vErrors = [err53];
                } else {
                  vErrors.push(err53);
                }
                errors++;
              } else {
                if (data.items !== undefined) {
                  let data45 = data.items;
                  const _errs106 = errors;
                  if (errors === _errs106) {
                    if (Array.isArray(data45)) {
                      var valid21 = true;
                      const len5 = data45.length;
                      for (let i5 = 0; i5 < len5; i5++) {
                        let data46 = data45[i5];
                        const _errs108 = errors;
                        if (
                          data46 &&
                          typeof data46 == 'object' &&
                          !Array.isArray(data46)
                        ) {
                          let missing7;
                          if (
                            (data46.id === undefined && (missing7 = 'id')) ||
                            (data46.received === undefined &&
                              (missing7 = 'received')) ||
                            (data46.timestamp === undefined &&
                              (missing7 = 'timestamp')) ||
                            (data46.type === undefined && (missing7 = 'type'))
                          ) {
                            const err54 = {
                              instancePath: instancePath + '/items/' + i5,
                              schemaPath:
                                'APICallbacksData.json/properties/items/items/required',
                              keyword: 'required',
                              params: { missingProperty: missing7 },
                              message:
                                "must have required property '" +
                                missing7 +
                                "'",
                            };
                            if (vErrors === null) {
                              vErrors = [err54];
                            } else {
                              vErrors.push(err54);
                            }
                            errors++;
                          } else {
                            if (data46.id !== undefined) {
                              const _errs109 = errors;
                              if (typeof data46.id !== 'string') {
                                const err55 = {
                                  instancePath:
                                    instancePath + '/items/' + i5 + '/id',
                                  schemaPath:
                                    'APICallbacksData.json/properties/items/items/properties/id/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                };
                                if (vErrors === null) {
                                  vErrors = [err55];
                                } else {
                                  vErrors.push(err55);
                                }
                                errors++;
                              }
                              var valid22 = _errs109 === errors;
                            } else {
                              var valid22 = true;
                            }
                            if (valid22) {
                              if (data46.received !== undefined) {
                                const _errs111 = errors;
                                if (typeof data46.received !== 'boolean') {
                                  const err56 = {
                                    instancePath:
                                      instancePath +
                                      '/items/' +
                                      i5 +
                                      '/received',
                                    schemaPath:
                                      'APICallbacksData.json/properties/items/items/properties/received/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean',
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err56];
                                  } else {
                                    vErrors.push(err56);
                                  }
                                  errors++;
                                }
                                var valid22 = _errs111 === errors;
                              } else {
                                var valid22 = true;
                              }
                              if (valid22) {
                                if (data46.timestamp !== undefined) {
                                  let data49 = data46.timestamp;
                                  const _errs113 = errors;
                                  if (
                                    !(
                                      typeof data49 == 'number' &&
                                      isFinite(data49)
                                    )
                                  ) {
                                    const err57 = {
                                      instancePath:
                                        instancePath +
                                        '/items/' +
                                        i5 +
                                        '/timestamp',
                                      schemaPath:
                                        'APICallbacksData.json/properties/items/items/properties/timestamp/type',
                                      keyword: 'type',
                                      params: { type: 'number' },
                                      message: 'must be number',
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err57];
                                    } else {
                                      vErrors.push(err57);
                                    }
                                    errors++;
                                  }
                                  var valid22 = _errs113 === errors;
                                } else {
                                  var valid22 = true;
                                }
                                if (valid22) {
                                  if (data46.type !== undefined) {
                                    const _errs115 = errors;
                                    if (typeof data46.type !== 'string') {
                                      const err58 = {
                                        instancePath:
                                          instancePath +
                                          '/items/' +
                                          i5 +
                                          '/type',
                                        schemaPath:
                                          'APICallbacksData.json/properties/items/items/properties/type/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err58];
                                      } else {
                                        vErrors.push(err58);
                                      }
                                      errors++;
                                    }
                                    var valid22 = _errs115 === errors;
                                  } else {
                                    var valid22 = true;
                                  }
                                }
                              }
                            }
                          }
                        }
                        var valid21 = _errs108 === errors;
                        if (!valid21) {
                          break;
                        }
                      }
                    } else {
                      const err59 = {
                        instancePath: instancePath + '/items',
                        schemaPath:
                          'APICallbacksData.json/properties/items/type',
                        keyword: 'type',
                        params: { type: 'array' },
                        message: 'must be array',
                      };
                      if (vErrors === null) {
                        vErrors = [err59];
                      } else {
                        vErrors.push(err59);
                      }
                      errors++;
                    }
                  }
                  var valid20 = _errs106 === errors;
                } else {
                  var valid20 = true;
                }
                if (valid20) {
                  if (data.count !== undefined) {
                    let data51 = data.count;
                    const _errs117 = errors;
                    if (!(typeof data51 == 'number' && isFinite(data51))) {
                      const err60 = {
                        instancePath: instancePath + '/count',
                        schemaPath:
                          'APICallbacksData.json/properties/count/type',
                        keyword: 'type',
                        params: { type: 'number' },
                        message: 'must be number',
                      };
                      if (vErrors === null) {
                        vErrors = [err60];
                      } else {
                        vErrors.push(err60);
                      }
                      errors++;
                    }
                    var valid20 = _errs117 === errors;
                  } else {
                    var valid20 = true;
                  }
                  if (valid20) {
                    if (data.page_size !== undefined) {
                      let data52 = data.page_size;
                      const _errs119 = errors;
                      if (!(typeof data52 == 'number' && isFinite(data52))) {
                        const err61 = {
                          instancePath: instancePath + '/page_size',
                          schemaPath:
                            'APICallbacksData.json/properties/page_size/type',
                          keyword: 'type',
                          params: { type: 'number' },
                          message: 'must be number',
                        };
                        if (vErrors === null) {
                          vErrors = [err61];
                        } else {
                          vErrors.push(err61);
                        }
                        errors++;
                      }
                      var valid20 = _errs119 === errors;
                    } else {
                      var valid20 = true;
                    }
                  }
                }
              }
            } else {
              const err62 = {
                instancePath,
                schemaPath: 'APICallbacksData.json/type',
                keyword: 'type',
                params: { type: 'object' },
                message: 'must be object',
              };
              if (vErrors === null) {
                vErrors = [err62];
              } else {
                vErrors.push(err62);
              }
              errors++;
            }
          }
          var _valid0 = _errs103 === errors;
          if (_valid0 && valid0) {
            valid0 = false;
            passing0 = [passing0, 5];
          } else {
            if (_valid0) {
              valid0 = true;
              passing0 = 5;
            }
            const _errs121 = errors;
            const _errs122 = errors;
            if (errors === _errs122) {
              if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing8;
                if (
                  (data.count === undefined && (missing8 = 'count')) ||
                  (data.page_size === undefined && (missing8 = 'page_size'))
                ) {
                  const err63 = {
                    instancePath,
                    schemaPath: 'APIRequestsData.json/required',
                    keyword: 'required',
                    params: { missingProperty: missing8 },
                    message: "must have required property '" + missing8 + "'",
                  };
                  if (vErrors === null) {
                    vErrors = [err63];
                  } else {
                    vErrors.push(err63);
                  }
                  errors++;
                } else {
                  if (data.items !== undefined) {
                    let data53 = data.items;
                    const _errs124 = errors;
                    if (errors === _errs124) {
                      if (Array.isArray(data53)) {
                        var valid25 = true;
                        const len6 = data53.length;
                        for (let i6 = 0; i6 < len6; i6++) {
                          let data54 = data53[i6];
                          const _errs126 = errors;
                          if (
                            data54 &&
                            typeof data54 == 'object' &&
                            !Array.isArray(data54)
                          ) {
                            let missing9;
                            if (
                              (data54.id === undefined && (missing9 = 'id')) ||
                              (data54.method === undefined &&
                                (missing9 = 'method')) ||
                              (data54.path === undefined &&
                                (missing9 = 'path')) ||
                              (data54.status === undefined &&
                                (missing9 = 'status')) ||
                              (data54.timestamp === undefined &&
                                (missing9 = 'timestamp'))
                            ) {
                              const err64 = {
                                instancePath: instancePath + '/items/' + i6,
                                schemaPath:
                                  'APIRequestsData.json/properties/items/items/required',
                                keyword: 'required',
                                params: { missingProperty: missing9 },
                                message:
                                  "must have required property '" +
                                  missing9 +
                                  "'",
                              };
                              if (vErrors === null) {
                                vErrors = [err64];
                              } else {
                                vErrors.push(err64);
                              }
                              errors++;
                            } else {
                              if (data54.id !== undefined) {
                                const _errs127 = errors;
                                if (typeof data54.id !== 'string') {
                                  const err65 = {
                                    instancePath:
                                      instancePath + '/items/' + i6 + '/id',
                                    schemaPath:
                                      'APIRequestsData.json/properties/items/items/properties/id/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err65];
                                  } else {
                                    vErrors.push(err65);
                                  }
                                  errors++;
                                }
                                var valid26 = _errs127 === errors;
                              } else {
                                var valid26 = true;
                              }
                              if (valid26) {
                                if (data54.method !== undefined) {
                                  const _errs129 = errors;
                                  if (typeof data54.method !== 'string') {
                                    const err66 = {
                                      instancePath:
                                        instancePath +
                                        '/items/' +
                                        i6 +
                                        '/method',
                                      schemaPath:
                                        'APIRequestsData.json/properties/items/items/properties/method/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err66];
                                    } else {
                                      vErrors.push(err66);
                                    }
                                    errors++;
                                  }
                                  var valid26 = _errs129 === errors;
                                } else {
                                  var valid26 = true;
                                }
                                if (valid26) {
                                  if (data54.path !== undefined) {
                                    const _errs131 = errors;
                                    if (typeof data54.path !== 'string') {
                                      const err67 = {
                                        instancePath:
                                          instancePath +
                                          '/items/' +
                                          i6 +
                                          '/path',
                                        schemaPath:
                                          'APIRequestsData.json/properties/items/items/properties/path/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err67];
                                      } else {
                                        vErrors.push(err67);
                                      }
                                      errors++;
                                    }
                                    var valid26 = _errs131 === errors;
                                  } else {
                                    var valid26 = true;
                                  }
                                  if (valid26) {
                                    if (data54.status !== undefined) {
                                      let data58 = data54.status;
                                      const _errs133 = errors;
                                      if (
                                        !(
                                          typeof data58 == 'number' &&
                                          isFinite(data58)
                                        )
                                      ) {
                                        const err68 = {
                                          instancePath:
                                            instancePath +
                                            '/items/' +
                                            i6 +
                                            '/status',
                                          schemaPath:
                                            'APIRequestsData.json/properties/items/items/properties/status/type',
                                          keyword: 'type',
                                          params: { type: 'number' },
                                          message: 'must be number',
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err68];
                                        } else {
                                          vErrors.push(err68);
                                        }
                                        errors++;
                                      }
                                      var valid26 = _errs133 === errors;
                                    } else {
                                      var valid26 = true;
                                    }
                                    if (valid26) {
                                      if (data54.timestamp !== undefined) {
                                        let data59 = data54.timestamp;
                                        const _errs135 = errors;
                                        if (
                                          !(
                                            typeof data59 == 'number' &&
                                            isFinite(data59)
                                          )
                                        ) {
                                          const err69 = {
                                            instancePath:
                                              instancePath +
                                              '/items/' +
                                              i6 +
                                              '/timestamp',
                                            schemaPath:
                                              'APIRequestsData.json/properties/items/items/properties/timestamp/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number',
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err69];
                                          } else {
                                            vErrors.push(err69);
                                          }
                                          errors++;
                                        }
                                        var valid26 = _errs135 === errors;
                                      } else {
                                        var valid26 = true;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                          var valid25 = _errs126 === errors;
                          if (!valid25) {
                            break;
                          }
                        }
                      } else {
                        const err70 = {
                          instancePath: instancePath + '/items',
                          schemaPath:
                            'APIRequestsData.json/properties/items/type',
                          keyword: 'type',
                          params: { type: 'array' },
                          message: 'must be array',
                        };
                        if (vErrors === null) {
                          vErrors = [err70];
                        } else {
                          vErrors.push(err70);
                        }
                        errors++;
                      }
                    }
                    var valid24 = _errs124 === errors;
                  } else {
                    var valid24 = true;
                  }
                  if (valid24) {
                    if (data.count !== undefined) {
                      let data60 = data.count;
                      const _errs137 = errors;
                      if (!(typeof data60 == 'number' && isFinite(data60))) {
                        const err71 = {
                          instancePath: instancePath + '/count',
                          schemaPath:
                            'APIRequestsData.json/properties/count/type',
                          keyword: 'type',
                          params: { type: 'number' },
                          message: 'must be number',
                        };
                        if (vErrors === null) {
                          vErrors = [err71];
                        } else {
                          vErrors.push(err71);
                        }
                        errors++;
                      }
                      var valid24 = _errs137 === errors;
                    } else {
                      var valid24 = true;
                    }
                    if (valid24) {
                      if (data.page_size !== undefined) {
                        let data61 = data.page_size;
                        const _errs139 = errors;
                        if (!(typeof data61 == 'number' && isFinite(data61))) {
                          const err72 = {
                            instancePath: instancePath + '/page_size',
                            schemaPath:
                              'APIRequestsData.json/properties/page_size/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                          };
                          if (vErrors === null) {
                            vErrors = [err72];
                          } else {
                            vErrors.push(err72);
                          }
                          errors++;
                        }
                        var valid24 = _errs139 === errors;
                      } else {
                        var valid24 = true;
                      }
                    }
                  }
                }
              } else {
                const err73 = {
                  instancePath,
                  schemaPath: 'APIRequestsData.json/type',
                  keyword: 'type',
                  params: { type: 'object' },
                  message: 'must be object',
                };
                if (vErrors === null) {
                  vErrors = [err73];
                } else {
                  vErrors.push(err73);
                }
                errors++;
              }
            }
            var _valid0 = _errs121 === errors;
            if (_valid0 && valid0) {
              valid0 = false;
              passing0 = [passing0, 6];
            } else {
              if (_valid0) {
                valid0 = true;
                passing0 = 6;
              }
              const _errs141 = errors;
              const _errs142 = errors;
              if (errors === _errs142) {
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                  let missing10;
                  if (
                    (data.event_data === undefined &&
                      (missing10 = 'event_data')) ||
                    (data.id === undefined && (missing10 = 'id')) ||
                    (data.timestamp === undefined &&
                      (missing10 = 'timestamp')) ||
                    (data.type === undefined && (missing10 = 'type'))
                  ) {
                    const err74 = {
                      instancePath,
                      schemaPath: 'APICallbackData.json/required',
                      keyword: 'required',
                      params: { missingProperty: missing10 },
                      message:
                        "must have required property '" + missing10 + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err74];
                    } else {
                      vErrors.push(err74);
                    }
                    errors++;
                  } else {
                    if (data.attempts !== undefined) {
                      let data62 = data.attempts;
                      const _errs144 = errors;
                      if (errors === _errs144) {
                        if (Array.isArray(data62)) {
                          var valid29 = true;
                          const len7 = data62.length;
                          for (let i7 = 0; i7 < len7; i7++) {
                            let data63 = data62[i7];
                            const _errs146 = errors;
                            if (
                              data63 &&
                              typeof data63 == 'object' &&
                              !Array.isArray(data63)
                            ) {
                              let missing11;
                              if (
                                (data63.error === undefined &&
                                  (missing11 = 'error')) ||
                                (data63.status_code === undefined &&
                                  (missing11 = 'status_code')) ||
                                (data63.response === undefined &&
                                  (missing11 = 'response')) ||
                                (data63.success === undefined &&
                                  (missing11 = 'success')) ||
                                (data63.timestamp === undefined &&
                                  (missing11 = 'timestamp')) ||
                                (data63.url === undefined &&
                                  (missing11 = 'url'))
                              ) {
                                const err75 = {
                                  instancePath:
                                    instancePath + '/attempts/' + i7,
                                  schemaPath:
                                    'APICallbackData.json/properties/attempts/items/required',
                                  keyword: 'required',
                                  params: { missingProperty: missing11 },
                                  message:
                                    "must have required property '" +
                                    missing11 +
                                    "'",
                                };
                                if (vErrors === null) {
                                  vErrors = [err75];
                                } else {
                                  vErrors.push(err75);
                                }
                                errors++;
                              } else {
                                if (data63.error !== undefined) {
                                  let data64 = data63.error;
                                  const _errs147 = errors;
                                  if (
                                    typeof data64 !== 'string' &&
                                    data64 !== null
                                  ) {
                                    const err76 = {
                                      instancePath:
                                        instancePath +
                                        '/attempts/' +
                                        i7 +
                                        '/error',
                                      schemaPath:
                                        'APICallbackData.json/properties/attempts/items/properties/error/type',
                                      keyword: 'type',
                                      params: {
                                        type: schema20.properties.attempts.items
                                          .properties.error.type,
                                      },
                                      message: 'must be string,null',
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err76];
                                    } else {
                                      vErrors.push(err76);
                                    }
                                    errors++;
                                  }
                                  var valid30 = _errs147 === errors;
                                } else {
                                  var valid30 = true;
                                }
                                if (valid30) {
                                  if (data63.url !== undefined) {
                                    let data65 = data63.url;
                                    const _errs149 = errors;
                                    if (
                                      typeof data65 !== 'string' &&
                                      data65 !== null
                                    ) {
                                      const err77 = {
                                        instancePath:
                                          instancePath +
                                          '/attempts/' +
                                          i7 +
                                          '/url',
                                        schemaPath:
                                          'APICallbackData.json/properties/attempts/items/properties/url/type',
                                        keyword: 'type',
                                        params: {
                                          type: schema20.properties.attempts
                                            .items.properties.url.type,
                                        },
                                        message: 'must be string,null',
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err77];
                                      } else {
                                        vErrors.push(err77);
                                      }
                                      errors++;
                                    }
                                    var valid30 = _errs149 === errors;
                                  } else {
                                    var valid30 = true;
                                  }
                                  if (valid30) {
                                    if (data63.status_code !== undefined) {
                                      let data66 = data63.status_code;
                                      const _errs151 = errors;
                                      if (
                                        !(
                                          typeof data66 == 'number' &&
                                          isFinite(data66)
                                        ) &&
                                        data66 !== null
                                      ) {
                                        const err78 = {
                                          instancePath:
                                            instancePath +
                                            '/attempts/' +
                                            i7 +
                                            '/status_code',
                                          schemaPath:
                                            'APICallbackData.json/properties/attempts/items/properties/status_code/type',
                                          keyword: 'type',
                                          params: {
                                            type: schema20.properties.attempts
                                              .items.properties.status_code
                                              .type,
                                          },
                                          message: 'must be number,null',
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err78];
                                        } else {
                                          vErrors.push(err78);
                                        }
                                        errors++;
                                      }
                                      var valid30 = _errs151 === errors;
                                    } else {
                                      var valid30 = true;
                                    }
                                    if (valid30) {
                                      if (data63.response !== undefined) {
                                        let data67 = data63.response;
                                        const _errs153 = errors;
                                        if (
                                          typeof data67 !== 'string' &&
                                          data67 !== null
                                        ) {
                                          const err79 = {
                                            instancePath:
                                              instancePath +
                                              '/attempts/' +
                                              i7 +
                                              '/response',
                                            schemaPath:
                                              'APICallbackData.json/properties/attempts/items/properties/response/type',
                                            keyword: 'type',
                                            params: {
                                              type: schema20.properties.attempts
                                                .items.properties.response.type,
                                            },
                                            message: 'must be string,null',
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err79];
                                          } else {
                                            vErrors.push(err79);
                                          }
                                          errors++;
                                        }
                                        var valid30 = _errs153 === errors;
                                      } else {
                                        var valid30 = true;
                                      }
                                      if (valid30) {
                                        if (data63.success !== undefined) {
                                          const _errs155 = errors;
                                          if (
                                            typeof data63.success !== 'boolean'
                                          ) {
                                            const err80 = {
                                              instancePath:
                                                instancePath +
                                                '/attempts/' +
                                                i7 +
                                                '/success',
                                              schemaPath:
                                                'APICallbackData.json/properties/attempts/items/properties/success/type',
                                              keyword: 'type',
                                              params: { type: 'boolean' },
                                              message: 'must be boolean',
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err80];
                                            } else {
                                              vErrors.push(err80);
                                            }
                                            errors++;
                                          }
                                          var valid30 = _errs155 === errors;
                                        } else {
                                          var valid30 = true;
                                        }
                                        if (valid30) {
                                          if (data63.timestamp !== undefined) {
                                            let data69 = data63.timestamp;
                                            const _errs157 = errors;
                                            if (
                                              !(
                                                typeof data69 == 'number' &&
                                                isFinite(data69)
                                              )
                                            ) {
                                              const err81 = {
                                                instancePath:
                                                  instancePath +
                                                  '/attempts/' +
                                                  i7 +
                                                  '/timestamp',
                                                schemaPath:
                                                  'APICallbackData.json/properties/attempts/items/properties/timestamp/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number',
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err81];
                                              } else {
                                                vErrors.push(err81);
                                              }
                                              errors++;
                                            }
                                            var valid30 = _errs157 === errors;
                                          } else {
                                            var valid30 = true;
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                            var valid29 = _errs146 === errors;
                            if (!valid29) {
                              break;
                            }
                          }
                        } else {
                          const err82 = {
                            instancePath: instancePath + '/attempts',
                            schemaPath:
                              'APICallbackData.json/properties/attempts/type',
                            keyword: 'type',
                            params: { type: 'array' },
                            message: 'must be array',
                          };
                          if (vErrors === null) {
                            vErrors = [err82];
                          } else {
                            vErrors.push(err82);
                          }
                          errors++;
                        }
                      }
                      var valid28 = _errs144 === errors;
                    } else {
                      var valid28 = true;
                    }
                    if (valid28) {
                      if (data.event_data !== undefined) {
                        let data70 = data.event_data;
                        const _errs159 = errors;
                        if (typeof data70 !== 'string' && data70 !== null) {
                          const err83 = {
                            instancePath: instancePath + '/event_data',
                            schemaPath:
                              'APICallbackData.json/properties/event_data/type',
                            keyword: 'type',
                            params: {
                              type: schema20.properties.event_data.type,
                            },
                            message: 'must be string,null',
                          };
                          if (vErrors === null) {
                            vErrors = [err83];
                          } else {
                            vErrors.push(err83);
                          }
                          errors++;
                        }
                        var valid28 = _errs159 === errors;
                      } else {
                        var valid28 = true;
                      }
                      if (valid28) {
                        if (data.id !== undefined) {
                          let data71 = data.id;
                          const _errs161 = errors;
                          if (typeof data71 !== 'string' && data71 !== null) {
                            const err84 = {
                              instancePath: instancePath + '/id',
                              schemaPath:
                                'APICallbackData.json/properties/id/type',
                              keyword: 'type',
                              params: { type: schema20.properties.id.type },
                              message: 'must be string,null',
                            };
                            if (vErrors === null) {
                              vErrors = [err84];
                            } else {
                              vErrors.push(err84);
                            }
                            errors++;
                          }
                          var valid28 = _errs161 === errors;
                        } else {
                          var valid28 = true;
                        }
                        if (valid28) {
                          if (data.timestamp !== undefined) {
                            let data72 = data.timestamp;
                            const _errs163 = errors;
                            if (
                              !(typeof data72 == 'number' && isFinite(data72))
                            ) {
                              const err85 = {
                                instancePath: instancePath + '/timestamp',
                                schemaPath:
                                  'APICallbackData.json/properties/timestamp/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number',
                              };
                              if (vErrors === null) {
                                vErrors = [err85];
                              } else {
                                vErrors.push(err85);
                              }
                              errors++;
                            }
                            var valid28 = _errs163 === errors;
                          } else {
                            var valid28 = true;
                          }
                          if (valid28) {
                            if (data.type !== undefined) {
                              let data73 = data.type;
                              const _errs165 = errors;
                              if (
                                typeof data73 !== 'string' &&
                                data73 !== null
                              ) {
                                const err86 = {
                                  instancePath: instancePath + '/type',
                                  schemaPath:
                                    'APICallbackData.json/properties/type/type',
                                  keyword: 'type',
                                  params: {
                                    type: schema20.properties.type.type,
                                  },
                                  message: 'must be string,null',
                                };
                                if (vErrors === null) {
                                  vErrors = [err86];
                                } else {
                                  vErrors.push(err86);
                                }
                                errors++;
                              }
                              var valid28 = _errs165 === errors;
                            } else {
                              var valid28 = true;
                            }
                          }
                        }
                      }
                    }
                  }
                } else {
                  const err87 = {
                    instancePath,
                    schemaPath: 'APICallbackData.json/type',
                    keyword: 'type',
                    params: { type: 'object' },
                    message: 'must be object',
                  };
                  if (vErrors === null) {
                    vErrors = [err87];
                  } else {
                    vErrors.push(err87);
                  }
                  errors++;
                }
              }
              var _valid0 = _errs141 === errors;
              if (_valid0 && valid0) {
                valid0 = false;
                passing0 = [passing0, 7];
              } else {
                if (_valid0) {
                  valid0 = true;
                  passing0 = 7;
                }
                const _errs167 = errors;
                const _errs168 = errors;
                if (errors === _errs168) {
                  if (Array.isArray(data)) {
                    var valid32 = true;
                    const len8 = data.length;
                    for (let i8 = 0; i8 < len8; i8++) {
                      const _errs170 = errors;
                      if (typeof data[i8] !== 'string') {
                        const err88 = {
                          instancePath: instancePath + '/' + i8,
                          schemaPath: 'APIEventTypesData.json/items/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        };
                        if (vErrors === null) {
                          vErrors = [err88];
                        } else {
                          vErrors.push(err88);
                        }
                        errors++;
                      }
                      var valid32 = _errs170 === errors;
                      if (!valid32) {
                        break;
                      }
                    }
                  } else {
                    const err89 = {
                      instancePath,
                      schemaPath: 'APIEventTypesData.json/type',
                      keyword: 'type',
                      params: { type: 'array' },
                      message: 'must be array',
                    };
                    if (vErrors === null) {
                      vErrors = [err89];
                    } else {
                      vErrors.push(err89);
                    }
                    errors++;
                  }
                }
                var _valid0 = _errs167 === errors;
                if (_valid0 && valid0) {
                  valid0 = false;
                  passing0 = [passing0, 8];
                } else {
                  if (_valid0) {
                    valid0 = true;
                    passing0 = 8;
                  }
                  const _errs172 = errors;
                  if (
                    !validate13(data, {
                      instancePath,
                      parentData,
                      parentDataProperty,
                      rootData,
                    })
                  ) {
                    vErrors =
                      vErrors === null
                        ? validate13.errors
                        : vErrors.concat(validate13.errors);
                    errors = vErrors.length;
                  }
                  var _valid0 = _errs172 === errors;
                  if (_valid0 && valid0) {
                    valid0 = false;
                    passing0 = [passing0, 9];
                  } else {
                    if (_valid0) {
                      valid0 = true;
                      passing0 = 9;
                    }
                    const _errs173 = errors;
                    const _errs174 = errors;
                    if (errors === _errs174) {
                      if (Array.isArray(data)) {
                        var valid34 = true;
                        const len9 = data.length;
                        for (let i9 = 0; i9 < len9; i9++) {
                          let data75 = data[i9];
                          const _errs176 = errors;
                          if (errors === _errs176) {
                            if (
                              data75 &&
                              typeof data75 == 'object' &&
                              !Array.isArray(data75)
                            ) {
                              let missing12;
                              if (
                                (data75.key === undefined &&
                                  (missing12 = 'key')) ||
                                (data75.value === undefined &&
                                  (missing12 = 'value')) ||
                                (data75.isSelected === undefined &&
                                  (missing12 = 'isSelected'))
                              ) {
                                const err90 = {
                                  instancePath: instancePath + '/' + i9,
                                  schemaPath:
                                    'APIEndpointListData.json/items/required',
                                  keyword: 'required',
                                  params: { missingProperty: missing12 },
                                  message:
                                    "must have required property '" +
                                    missing12 +
                                    "'",
                                };
                                if (vErrors === null) {
                                  vErrors = [err90];
                                } else {
                                  vErrors.push(err90);
                                }
                                errors++;
                              } else {
                                if (data75.key !== undefined) {
                                  const _errs178 = errors;
                                  if (typeof data75.key !== 'string') {
                                    const err91 = {
                                      instancePath:
                                        instancePath + '/' + i9 + '/key',
                                      schemaPath:
                                        'APIEndpointListData.json/items/properties/key/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err91];
                                    } else {
                                      vErrors.push(err91);
                                    }
                                    errors++;
                                  }
                                  var valid35 = _errs178 === errors;
                                } else {
                                  var valid35 = true;
                                }
                                if (valid35) {
                                  if (data75.value !== undefined) {
                                    const _errs180 = errors;
                                    if (typeof data75.value !== 'string') {
                                      const err92 = {
                                        instancePath:
                                          instancePath + '/' + i9 + '/value',
                                        schemaPath:
                                          'APIEndpointListData.json/items/properties/value/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err92];
                                      } else {
                                        vErrors.push(err92);
                                      }
                                      errors++;
                                    }
                                    var valid35 = _errs180 === errors;
                                  } else {
                                    var valid35 = true;
                                  }
                                  if (valid35) {
                                    if (data75.isSelected !== undefined) {
                                      const _errs182 = errors;
                                      if (
                                        typeof data75.isSelected !== 'boolean'
                                      ) {
                                        const err93 = {
                                          instancePath:
                                            instancePath +
                                            '/' +
                                            i9 +
                                            '/isSelected',
                                          schemaPath:
                                            'APIEndpointListData.json/items/properties/isSelected/type',
                                          keyword: 'type',
                                          params: { type: 'boolean' },
                                          message: 'must be boolean',
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err93];
                                        } else {
                                          vErrors.push(err93);
                                        }
                                        errors++;
                                      }
                                      var valid35 = _errs182 === errors;
                                    } else {
                                      var valid35 = true;
                                    }
                                  }
                                }
                              }
                            } else {
                              const err94 = {
                                instancePath: instancePath + '/' + i9,
                                schemaPath:
                                  'APIEndpointListData.json/items/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object',
                              };
                              if (vErrors === null) {
                                vErrors = [err94];
                              } else {
                                vErrors.push(err94);
                              }
                              errors++;
                            }
                          }
                          var valid34 = _errs176 === errors;
                          if (!valid34) {
                            break;
                          }
                        }
                      } else {
                        const err95 = {
                          instancePath,
                          schemaPath: 'APIEndpointListData.json/type',
                          keyword: 'type',
                          params: { type: 'array' },
                          message: 'must be array',
                        };
                        if (vErrors === null) {
                          vErrors = [err95];
                        } else {
                          vErrors.push(err95);
                        }
                        errors++;
                      }
                    }
                    var _valid0 = _errs173 === errors;
                    if (_valid0 && valid0) {
                      valid0 = false;
                      passing0 = [passing0, 10];
                    } else {
                      if (_valid0) {
                        valid0 = true;
                        passing0 = 10;
                      }
                      const _errs184 = errors;
                      const _errs185 = errors;
                      if (errors === _errs185) {
                        if (
                          data &&
                          typeof data == 'object' &&
                          !Array.isArray(data)
                        ) {
                          let missing13;
                          if (
                            (data.success_data === undefined &&
                              (missing13 = 'success_data')) ||
                            (data.failure_data === undefined &&
                              (missing13 = 'failure_data')) ||
                            (data.dates === undefined && (missing13 = 'dates'))
                          ) {
                            const err96 = {
                              instancePath,
                              schemaPath:
                                'APIRequestsErrorDistributionData.json/required',
                              keyword: 'required',
                              params: { missingProperty: missing13 },
                              message:
                                "must have required property '" +
                                missing13 +
                                "'",
                            };
                            if (vErrors === null) {
                              vErrors = [err96];
                            } else {
                              vErrors.push(err96);
                            }
                            errors++;
                          } else {
                            if (data.success_data !== undefined) {
                              let data79 = data.success_data;
                              const _errs187 = errors;
                              if (errors === _errs187) {
                                if (Array.isArray(data79)) {
                                  var valid38 = true;
                                  const len10 = data79.length;
                                  for (let i10 = 0; i10 < len10; i10++) {
                                    let data80 = data79[i10];
                                    const _errs189 = errors;
                                    if (
                                      !(
                                        typeof data80 == 'number' &&
                                        isFinite(data80)
                                      )
                                    ) {
                                      const err97 = {
                                        instancePath:
                                          instancePath + '/success_data/' + i10,
                                        schemaPath:
                                          'APIRequestsErrorDistributionData.json/properties/success_data/items/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number',
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err97];
                                      } else {
                                        vErrors.push(err97);
                                      }
                                      errors++;
                                    }
                                    var valid38 = _errs189 === errors;
                                    if (!valid38) {
                                      break;
                                    }
                                  }
                                } else {
                                  const err98 = {
                                    instancePath:
                                      instancePath + '/success_data',
                                    schemaPath:
                                      'APIRequestsErrorDistributionData.json/properties/success_data/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array',
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err98];
                                  } else {
                                    vErrors.push(err98);
                                  }
                                  errors++;
                                }
                              }
                              var valid37 = _errs187 === errors;
                            } else {
                              var valid37 = true;
                            }
                            if (valid37) {
                              if (data.failure_data !== undefined) {
                                let data81 = data.failure_data;
                                const _errs191 = errors;
                                if (errors === _errs191) {
                                  if (Array.isArray(data81)) {
                                    var valid39 = true;
                                    const len11 = data81.length;
                                    for (let i11 = 0; i11 < len11; i11++) {
                                      let data82 = data81[i11];
                                      const _errs193 = errors;
                                      if (
                                        !(
                                          typeof data82 == 'number' &&
                                          isFinite(data82)
                                        )
                                      ) {
                                        const err99 = {
                                          instancePath:
                                            instancePath +
                                            '/failure_data/' +
                                            i11,
                                          schemaPath:
                                            'APIRequestsErrorDistributionData.json/properties/failure_data/items/type',
                                          keyword: 'type',
                                          params: { type: 'number' },
                                          message: 'must be number',
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err99];
                                        } else {
                                          vErrors.push(err99);
                                        }
                                        errors++;
                                      }
                                      var valid39 = _errs193 === errors;
                                      if (!valid39) {
                                        break;
                                      }
                                    }
                                  } else {
                                    const err100 = {
                                      instancePath:
                                        instancePath + '/failure_data',
                                      schemaPath:
                                        'APIRequestsErrorDistributionData.json/properties/failure_data/type',
                                      keyword: 'type',
                                      params: { type: 'array' },
                                      message: 'must be array',
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err100];
                                    } else {
                                      vErrors.push(err100);
                                    }
                                    errors++;
                                  }
                                }
                                var valid37 = _errs191 === errors;
                              } else {
                                var valid37 = true;
                              }
                              if (valid37) {
                                if (data.dates !== undefined) {
                                  let data83 = data.dates;
                                  const _errs195 = errors;
                                  if (errors === _errs195) {
                                    if (Array.isArray(data83)) {
                                      var valid40 = true;
                                      const len12 = data83.length;
                                      for (let i12 = 0; i12 < len12; i12++) {
                                        const _errs197 = errors;
                                        if (typeof data83[i12] !== 'string') {
                                          const err101 = {
                                            instancePath:
                                              instancePath + '/dates/' + i12,
                                            schemaPath:
                                              'APIRequestsErrorDistributionData.json/properties/dates/items/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err101];
                                          } else {
                                            vErrors.push(err101);
                                          }
                                          errors++;
                                        }
                                        var valid40 = _errs197 === errors;
                                        if (!valid40) {
                                          break;
                                        }
                                      }
                                    } else {
                                      const err102 = {
                                        instancePath: instancePath + '/dates',
                                        schemaPath:
                                          'APIRequestsErrorDistributionData.json/properties/dates/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array',
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err102];
                                      } else {
                                        vErrors.push(err102);
                                      }
                                      errors++;
                                    }
                                  }
                                  var valid37 = _errs195 === errors;
                                } else {
                                  var valid37 = true;
                                }
                              }
                            }
                          }
                        } else {
                          const err103 = {
                            instancePath,
                            schemaPath:
                              'APIRequestsErrorDistributionData.json/type',
                            keyword: 'type',
                            params: { type: 'object' },
                            message: 'must be object',
                          };
                          if (vErrors === null) {
                            vErrors = [err103];
                          } else {
                            vErrors.push(err103);
                          }
                          errors++;
                        }
                      }
                      var _valid0 = _errs184 === errors;
                      if (_valid0 && valid0) {
                        valid0 = false;
                        passing0 = [passing0, 11];
                      } else {
                        if (_valid0) {
                          valid0 = true;
                          passing0 = 11;
                        }
                        const _errs199 = errors;
                        const _errs200 = errors;
                        if (errors === _errs200) {
                          if (
                            data &&
                            typeof data == 'object' &&
                            !Array.isArray(data)
                          ) {
                            let missing14;
                            if (
                              (data.count === undefined &&
                                (missing14 = 'count')) ||
                              (data.page_size === undefined &&
                                (missing14 = 'page_size'))
                            ) {
                              const err104 = {
                                instancePath,
                                schemaPath:
                                  'APISignatureRequestsData.json/required',
                                keyword: 'required',
                                params: { missingProperty: missing14 },
                                message:
                                  "must have required property '" +
                                  missing14 +
                                  "'",
                              };
                              if (vErrors === null) {
                                vErrors = [err104];
                              } else {
                                vErrors.push(err104);
                              }
                              errors++;
                            } else {
                              if (data.items !== undefined) {
                                let data85 = data.items;
                                const _errs202 = errors;
                                if (errors === _errs202) {
                                  if (Array.isArray(data85)) {
                                    var valid43 = true;
                                    const len13 = data85.length;
                                    for (let i13 = 0; i13 < len13; i13++) {
                                      let data86 = data85[i13];
                                      const _errs204 = errors;
                                      if (
                                        data86 &&
                                        typeof data86 == 'object' &&
                                        !Array.isArray(data86)
                                      ) {
                                        let missing15;
                                        if (
                                          (data86.id === undefined &&
                                            (missing15 = 'id')) ||
                                          (data86.status === undefined &&
                                            (missing15 = 'status')) ||
                                          (data86.timestamp === undefined &&
                                            (missing15 = 'timestamp'))
                                        ) {
                                          const err105 = {
                                            instancePath:
                                              instancePath + '/items/' + i13,
                                            schemaPath:
                                              'APISignatureRequestsData.json/properties/items/items/required',
                                            keyword: 'required',
                                            params: {
                                              missingProperty: missing15,
                                            },
                                            message:
                                              "must have required property '" +
                                              missing15 +
                                              "'",
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err105];
                                          } else {
                                            vErrors.push(err105);
                                          }
                                          errors++;
                                        } else {
                                          if (data86.id !== undefined) {
                                            const _errs205 = errors;
                                            if (typeof data86.id !== 'string') {
                                              const err106 = {
                                                instancePath:
                                                  instancePath +
                                                  '/items/' +
                                                  i13 +
                                                  '/id',
                                                schemaPath:
                                                  'APISignatureRequestsData.json/properties/items/items/properties/id/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err106];
                                              } else {
                                                vErrors.push(err106);
                                              }
                                              errors++;
                                            }
                                            var valid44 = _errs205 === errors;
                                          } else {
                                            var valid44 = true;
                                          }
                                          if (valid44) {
                                            if (data86.status !== undefined) {
                                              const _errs207 = errors;
                                              if (
                                                typeof data86.status !==
                                                'string'
                                              ) {
                                                const err107 = {
                                                  instancePath:
                                                    instancePath +
                                                    '/items/' +
                                                    i13 +
                                                    '/status',
                                                  schemaPath:
                                                    'APISignatureRequestsData.json/properties/items/items/properties/status/type',
                                                  keyword: 'type',
                                                  params: { type: 'string' },
                                                  message: 'must be string',
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err107];
                                                } else {
                                                  vErrors.push(err107);
                                                }
                                                errors++;
                                              }
                                              var valid44 = _errs207 === errors;
                                            } else {
                                              var valid44 = true;
                                            }
                                            if (valid44) {
                                              if (
                                                data86.timestamp !== undefined
                                              ) {
                                                let data89 = data86.timestamp;
                                                const _errs209 = errors;
                                                if (
                                                  !(
                                                    typeof data89 == 'number' &&
                                                    isFinite(data89)
                                                  )
                                                ) {
                                                  const err108 = {
                                                    instancePath:
                                                      instancePath +
                                                      '/items/' +
                                                      i13 +
                                                      '/timestamp',
                                                    schemaPath:
                                                      'APISignatureRequestsData.json/properties/items/items/properties/timestamp/type',
                                                    keyword: 'type',
                                                    params: { type: 'number' },
                                                    message: 'must be number',
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err108];
                                                  } else {
                                                    vErrors.push(err108);
                                                  }
                                                  errors++;
                                                }
                                                var valid44 =
                                                  _errs209 === errors;
                                              } else {
                                                var valid44 = true;
                                              }
                                            }
                                          }
                                        }
                                      }
                                      var valid43 = _errs204 === errors;
                                      if (!valid43) {
                                        break;
                                      }
                                    }
                                  } else {
                                    const err109 = {
                                      instancePath: instancePath + '/items',
                                      schemaPath:
                                        'APISignatureRequestsData.json/properties/items/type',
                                      keyword: 'type',
                                      params: { type: 'array' },
                                      message: 'must be array',
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err109];
                                    } else {
                                      vErrors.push(err109);
                                    }
                                    errors++;
                                  }
                                }
                                var valid42 = _errs202 === errors;
                              } else {
                                var valid42 = true;
                              }
                              if (valid42) {
                                if (data.count !== undefined) {
                                  let data90 = data.count;
                                  const _errs211 = errors;
                                  if (
                                    !(
                                      typeof data90 == 'number' &&
                                      isFinite(data90)
                                    )
                                  ) {
                                    const err110 = {
                                      instancePath: instancePath + '/count',
                                      schemaPath:
                                        'APISignatureRequestsData.json/properties/count/type',
                                      keyword: 'type',
                                      params: { type: 'number' },
                                      message: 'must be number',
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err110];
                                    } else {
                                      vErrors.push(err110);
                                    }
                                    errors++;
                                  }
                                  var valid42 = _errs211 === errors;
                                } else {
                                  var valid42 = true;
                                }
                                if (valid42) {
                                  if (data.page_size !== undefined) {
                                    let data91 = data.page_size;
                                    const _errs213 = errors;
                                    if (
                                      !(
                                        typeof data91 == 'number' &&
                                        isFinite(data91)
                                      )
                                    ) {
                                      const err111 = {
                                        instancePath:
                                          instancePath + '/page_size',
                                        schemaPath:
                                          'APISignatureRequestsData.json/properties/page_size/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number',
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err111];
                                      } else {
                                        vErrors.push(err111);
                                      }
                                      errors++;
                                    }
                                    var valid42 = _errs213 === errors;
                                  } else {
                                    var valid42 = true;
                                  }
                                }
                              }
                            }
                          } else {
                            const err112 = {
                              instancePath,
                              schemaPath: 'APISignatureRequestsData.json/type',
                              keyword: 'type',
                              params: { type: 'object' },
                              message: 'must be object',
                            };
                            if (vErrors === null) {
                              vErrors = [err112];
                            } else {
                              vErrors.push(err112);
                            }
                            errors++;
                          }
                        }
                        var _valid0 = _errs199 === errors;
                        if (_valid0 && valid0) {
                          valid0 = false;
                          passing0 = [passing0, 12];
                        } else {
                          if (_valid0) {
                            valid0 = true;
                            passing0 = 12;
                          }
                          const _errs215 = errors;
                          const _errs216 = errors;
                          if (errors === _errs216) {
                            if (
                              data &&
                              typeof data == 'object' &&
                              !Array.isArray(data)
                            ) {
                              let missing16;
                              if (
                                data.result_counts === undefined &&
                                (missing16 = 'result_counts')
                              ) {
                                const err113 = {
                                  instancePath,
                                  schemaPath:
                                    'APISearchResultData.json/required',
                                  keyword: 'required',
                                  params: { missingProperty: missing16 },
                                  message:
                                    "must have required property '" +
                                    missing16 +
                                    "'",
                                };
                                if (vErrors === null) {
                                  vErrors = [err113];
                                } else {
                                  vErrors.push(err113);
                                }
                                errors++;
                              } else {
                                if (data.page_size !== undefined) {
                                  let data92 = data.page_size;
                                  const _errs218 = errors;
                                  if (
                                    !(
                                      typeof data92 == 'number' &&
                                      isFinite(data92)
                                    )
                                  ) {
                                    const err114 = {
                                      instancePath: instancePath + '/page_size',
                                      schemaPath:
                                        'APISearchResultData.json/properties/page_size/type',
                                      keyword: 'type',
                                      params: { type: 'number' },
                                      message: 'must be number',
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err114];
                                    } else {
                                      vErrors.push(err114);
                                    }
                                    errors++;
                                  }
                                  var valid46 = _errs218 === errors;
                                } else {
                                  var valid46 = true;
                                }
                                if (valid46) {
                                  if (data.result_counts !== undefined) {
                                    let data93 = data.result_counts;
                                    const _errs220 = errors;
                                    if (errors === _errs220) {
                                      if (
                                        data93 &&
                                        typeof data93 == 'object' &&
                                        !Array.isArray(data93)
                                      ) {
                                        let missing17;
                                        if (
                                          (data93.signature_request ===
                                            undefined &&
                                            (missing17 =
                                              'signature_request')) ||
                                          (data93.api_request === undefined &&
                                            (missing17 = 'api_request')) ||
                                          (data93.account_callback ===
                                            undefined &&
                                            (missing17 = 'account_callback')) ||
                                          (data93.app_callback === undefined &&
                                            (missing17 = 'app_callback'))
                                        ) {
                                          const err115 = {
                                            instancePath:
                                              instancePath + '/result_counts',
                                            schemaPath:
                                              'APISearchResultData.json/properties/result_counts/required',
                                            keyword: 'required',
                                            params: {
                                              missingProperty: missing17,
                                            },
                                            message:
                                              "must have required property '" +
                                              missing17 +
                                              "'",
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err115];
                                          } else {
                                            vErrors.push(err115);
                                          }
                                          errors++;
                                        } else {
                                          if (
                                            data93.signature_request !==
                                            undefined
                                          ) {
                                            let data94 =
                                              data93.signature_request;
                                            const _errs222 = errors;
                                            if (
                                              !(
                                                typeof data94 == 'number' &&
                                                isFinite(data94)
                                              )
                                            ) {
                                              const err116 = {
                                                instancePath:
                                                  instancePath +
                                                  '/result_counts/signature_request',
                                                schemaPath:
                                                  'APISearchResultData.json/properties/result_counts/properties/signature_request/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number',
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err116];
                                              } else {
                                                vErrors.push(err116);
                                              }
                                              errors++;
                                            }
                                            var valid47 = _errs222 === errors;
                                          } else {
                                            var valid47 = true;
                                          }
                                          if (valid47) {
                                            if (
                                              data93.api_request !== undefined
                                            ) {
                                              let data95 = data93.api_request;
                                              const _errs224 = errors;
                                              if (
                                                !(
                                                  typeof data95 == 'number' &&
                                                  isFinite(data95)
                                                )
                                              ) {
                                                const err117 = {
                                                  instancePath:
                                                    instancePath +
                                                    '/result_counts/api_request',
                                                  schemaPath:
                                                    'APISearchResultData.json/properties/result_counts/properties/api_request/type',
                                                  keyword: 'type',
                                                  params: { type: 'number' },
                                                  message: 'must be number',
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err117];
                                                } else {
                                                  vErrors.push(err117);
                                                }
                                                errors++;
                                              }
                                              var valid47 = _errs224 === errors;
                                            } else {
                                              var valid47 = true;
                                            }
                                            if (valid47) {
                                              if (
                                                data93.account_callback !==
                                                undefined
                                              ) {
                                                let data96 =
                                                  data93.account_callback;
                                                const _errs226 = errors;
                                                if (
                                                  !(
                                                    typeof data96 == 'number' &&
                                                    isFinite(data96)
                                                  )
                                                ) {
                                                  const err118 = {
                                                    instancePath:
                                                      instancePath +
                                                      '/result_counts/account_callback',
                                                    schemaPath:
                                                      'APISearchResultData.json/properties/result_counts/properties/account_callback/type',
                                                    keyword: 'type',
                                                    params: { type: 'number' },
                                                    message: 'must be number',
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err118];
                                                  } else {
                                                    vErrors.push(err118);
                                                  }
                                                  errors++;
                                                }
                                                var valid47 =
                                                  _errs226 === errors;
                                              } else {
                                                var valid47 = true;
                                              }
                                              if (valid47) {
                                                if (
                                                  data93.app_callback !==
                                                  undefined
                                                ) {
                                                  let data97 =
                                                    data93.app_callback;
                                                  const _errs228 = errors;
                                                  if (
                                                    !(
                                                      typeof data97 ==
                                                        'number' &&
                                                      isFinite(data97)
                                                    )
                                                  ) {
                                                    const err119 = {
                                                      instancePath:
                                                        instancePath +
                                                        '/result_counts/app_callback',
                                                      schemaPath:
                                                        'APISearchResultData.json/properties/result_counts/properties/app_callback/type',
                                                      keyword: 'type',
                                                      params: {
                                                        type: 'number',
                                                      },
                                                      message: 'must be number',
                                                    };
                                                    if (vErrors === null) {
                                                      vErrors = [err119];
                                                    } else {
                                                      vErrors.push(err119);
                                                    }
                                                    errors++;
                                                  }
                                                  var valid47 =
                                                    _errs228 === errors;
                                                } else {
                                                  var valid47 = true;
                                                }
                                              }
                                            }
                                          }
                                        }
                                      } else {
                                        const err120 = {
                                          instancePath:
                                            instancePath + '/result_counts',
                                          schemaPath:
                                            'APISearchResultData.json/properties/result_counts/type',
                                          keyword: 'type',
                                          params: { type: 'object' },
                                          message: 'must be object',
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err120];
                                        } else {
                                          vErrors.push(err120);
                                        }
                                        errors++;
                                      }
                                    }
                                    var valid46 = _errs220 === errors;
                                  } else {
                                    var valid46 = true;
                                  }
                                }
                              }
                            } else {
                              const err121 = {
                                instancePath,
                                schemaPath: 'APISearchResultData.json/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object',
                              };
                              if (vErrors === null) {
                                vErrors = [err121];
                              } else {
                                vErrors.push(err121);
                              }
                              errors++;
                            }
                          }
                          var _valid0 = _errs215 === errors;
                          if (_valid0 && valid0) {
                            valid0 = false;
                            passing0 = [passing0, 13];
                          } else {
                            if (_valid0) {
                              valid0 = true;
                              passing0 = 13;
                            }
                            const _errs230 = errors;
                            const _errs231 = errors;
                            if (errors === _errs231) {
                              if (
                                data &&
                                typeof data == 'object' &&
                                !Array.isArray(data)
                              ) {
                                let missing18;
                                if (
                                  (data.count === undefined &&
                                    (missing18 = 'count')) ||
                                  (data.page_size === undefined &&
                                    (missing18 = 'page_size'))
                                ) {
                                  const err122 = {
                                    instancePath,
                                    schemaPath:
                                      'APISignatureRequestsData.json/required',
                                    keyword: 'required',
                                    params: { missingProperty: missing18 },
                                    message:
                                      "must have required property '" +
                                      missing18 +
                                      "'",
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err122];
                                  } else {
                                    vErrors.push(err122);
                                  }
                                  errors++;
                                } else {
                                  if (data.items !== undefined) {
                                    let data98 = data.items;
                                    const _errs233 = errors;
                                    if (errors === _errs233) {
                                      if (Array.isArray(data98)) {
                                        var valid50 = true;
                                        const len14 = data98.length;
                                        for (let i14 = 0; i14 < len14; i14++) {
                                          let data99 = data98[i14];
                                          const _errs235 = errors;
                                          if (
                                            data99 &&
                                            typeof data99 == 'object' &&
                                            !Array.isArray(data99)
                                          ) {
                                            let missing19;
                                            if (
                                              (data99.id === undefined &&
                                                (missing19 = 'id')) ||
                                              (data99.status === undefined &&
                                                (missing19 = 'status')) ||
                                              (data99.timestamp === undefined &&
                                                (missing19 = 'timestamp'))
                                            ) {
                                              const err123 = {
                                                instancePath:
                                                  instancePath +
                                                  '/items/' +
                                                  i14,
                                                schemaPath:
                                                  'APISignatureRequestsData.json/properties/items/items/required',
                                                keyword: 'required',
                                                params: {
                                                  missingProperty: missing19,
                                                },
                                                message:
                                                  "must have required property '" +
                                                  missing19 +
                                                  "'",
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err123];
                                              } else {
                                                vErrors.push(err123);
                                              }
                                              errors++;
                                            } else {
                                              if (data99.id !== undefined) {
                                                const _errs236 = errors;
                                                if (
                                                  typeof data99.id !== 'string'
                                                ) {
                                                  const err124 = {
                                                    instancePath:
                                                      instancePath +
                                                      '/items/' +
                                                      i14 +
                                                      '/id',
                                                    schemaPath:
                                                      'APISignatureRequestsData.json/properties/items/items/properties/id/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string',
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err124];
                                                  } else {
                                                    vErrors.push(err124);
                                                  }
                                                  errors++;
                                                }
                                                var valid51 =
                                                  _errs236 === errors;
                                              } else {
                                                var valid51 = true;
                                              }
                                              if (valid51) {
                                                if (
                                                  data99.status !== undefined
                                                ) {
                                                  const _errs238 = errors;
                                                  if (
                                                    typeof data99.status !==
                                                    'string'
                                                  ) {
                                                    const err125 = {
                                                      instancePath:
                                                        instancePath +
                                                        '/items/' +
                                                        i14 +
                                                        '/status',
                                                      schemaPath:
                                                        'APISignatureRequestsData.json/properties/items/items/properties/status/type',
                                                      keyword: 'type',
                                                      params: {
                                                        type: 'string',
                                                      },
                                                      message: 'must be string',
                                                    };
                                                    if (vErrors === null) {
                                                      vErrors = [err125];
                                                    } else {
                                                      vErrors.push(err125);
                                                    }
                                                    errors++;
                                                  }
                                                  var valid51 =
                                                    _errs238 === errors;
                                                } else {
                                                  var valid51 = true;
                                                }
                                                if (valid51) {
                                                  if (
                                                    data99.timestamp !==
                                                    undefined
                                                  ) {
                                                    let data102 =
                                                      data99.timestamp;
                                                    const _errs240 = errors;
                                                    if (
                                                      !(
                                                        typeof data102 ==
                                                          'number' &&
                                                        isFinite(data102)
                                                      )
                                                    ) {
                                                      const err126 = {
                                                        instancePath:
                                                          instancePath +
                                                          '/items/' +
                                                          i14 +
                                                          '/timestamp',
                                                        schemaPath:
                                                          'APISignatureRequestsData.json/properties/items/items/properties/timestamp/type',
                                                        keyword: 'type',
                                                        params: {
                                                          type: 'number',
                                                        },
                                                        message:
                                                          'must be number',
                                                      };
                                                      if (vErrors === null) {
                                                        vErrors = [err126];
                                                      } else {
                                                        vErrors.push(err126);
                                                      }
                                                      errors++;
                                                    }
                                                    var valid51 =
                                                      _errs240 === errors;
                                                  } else {
                                                    var valid51 = true;
                                                  }
                                                }
                                              }
                                            }
                                          }
                                          var valid50 = _errs235 === errors;
                                          if (!valid50) {
                                            break;
                                          }
                                        }
                                      } else {
                                        const err127 = {
                                          instancePath: instancePath + '/items',
                                          schemaPath:
                                            'APISignatureRequestsData.json/properties/items/type',
                                          keyword: 'type',
                                          params: { type: 'array' },
                                          message: 'must be array',
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err127];
                                        } else {
                                          vErrors.push(err127);
                                        }
                                        errors++;
                                      }
                                    }
                                    var valid49 = _errs233 === errors;
                                  } else {
                                    var valid49 = true;
                                  }
                                  if (valid49) {
                                    if (data.count !== undefined) {
                                      let data103 = data.count;
                                      const _errs242 = errors;
                                      if (
                                        !(
                                          typeof data103 == 'number' &&
                                          isFinite(data103)
                                        )
                                      ) {
                                        const err128 = {
                                          instancePath: instancePath + '/count',
                                          schemaPath:
                                            'APISignatureRequestsData.json/properties/count/type',
                                          keyword: 'type',
                                          params: { type: 'number' },
                                          message: 'must be number',
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err128];
                                        } else {
                                          vErrors.push(err128);
                                        }
                                        errors++;
                                      }
                                      var valid49 = _errs242 === errors;
                                    } else {
                                      var valid49 = true;
                                    }
                                    if (valid49) {
                                      if (data.page_size !== undefined) {
                                        let data104 = data.page_size;
                                        const _errs244 = errors;
                                        if (
                                          !(
                                            typeof data104 == 'number' &&
                                            isFinite(data104)
                                          )
                                        ) {
                                          const err129 = {
                                            instancePath:
                                              instancePath + '/page_size',
                                            schemaPath:
                                              'APISignatureRequestsData.json/properties/page_size/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number',
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err129];
                                          } else {
                                            vErrors.push(err129);
                                          }
                                          errors++;
                                        }
                                        var valid49 = _errs244 === errors;
                                      } else {
                                        var valid49 = true;
                                      }
                                    }
                                  }
                                }
                              } else {
                                const err130 = {
                                  instancePath,
                                  schemaPath:
                                    'APISignatureRequestsData.json/type',
                                  keyword: 'type',
                                  params: { type: 'object' },
                                  message: 'must be object',
                                };
                                if (vErrors === null) {
                                  vErrors = [err130];
                                } else {
                                  vErrors.push(err130);
                                }
                                errors++;
                              }
                            }
                            var _valid0 = _errs230 === errors;
                            if (_valid0 && valid0) {
                              valid0 = false;
                              passing0 = [passing0, 14];
                            } else {
                              if (_valid0) {
                                valid0 = true;
                                passing0 = 14;
                              }
                              const _errs246 = errors;
                              if (
                                !validate15(data, {
                                  instancePath,
                                  parentData,
                                  parentDataProperty,
                                  rootData,
                                })
                              ) {
                                vErrors =
                                  vErrors === null
                                    ? validate15.errors
                                    : vErrors.concat(validate15.errors);
                                errors = vErrors.length;
                              }
                              var _valid0 = _errs246 === errors;
                              if (_valid0 && valid0) {
                                valid0 = false;
                                passing0 = [passing0, 15];
                              } else {
                                if (_valid0) {
                                  valid0 = true;
                                  passing0 = 15;
                                }
                                const _errs247 = errors;
                                if (
                                  !validate17(data, {
                                    instancePath,
                                    parentData,
                                    parentDataProperty,
                                    rootData,
                                  })
                                ) {
                                  vErrors =
                                    vErrors === null
                                      ? validate17.errors
                                      : vErrors.concat(validate17.errors);
                                  errors = vErrors.length;
                                }
                                var _valid0 = _errs247 === errors;
                                if (_valid0 && valid0) {
                                  valid0 = false;
                                  passing0 = [passing0, 16];
                                } else {
                                  if (_valid0) {
                                    valid0 = true;
                                    passing0 = 16;
                                  }
                                  const _errs248 = errors;
                                  if (
                                    !validate19(data, {
                                      instancePath,
                                      parentData,
                                      parentDataProperty,
                                      rootData,
                                    })
                                  ) {
                                    vErrors =
                                      vErrors === null
                                        ? validate19.errors
                                        : vErrors.concat(validate19.errors);
                                    errors = vErrors.length;
                                  }
                                  var _valid0 = _errs248 === errors;
                                  if (_valid0 && valid0) {
                                    valid0 = false;
                                    passing0 = [passing0, 17];
                                  } else {
                                    if (_valid0) {
                                      valid0 = true;
                                      passing0 = 17;
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  if (!valid0) {
    const err131 = {
      instancePath,
      schemaPath: '#/oneOf',
      keyword: 'oneOf',
      params: { passingSchemas: passing0 },
      message: 'must match exactly one schema in oneOf',
    };
    if (vErrors === null) {
      vErrors = [err131];
    } else {
      vErrors.push(err131);
    }
    errors++;
    validate10.errors = vErrors;
    return false;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  validate10.errors = vErrors;
  return errors === 0;
}
exports.validateAPIUsageData = validate23;
function validate23(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="APIUsageData.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.account_id === undefined && (missing0 = 'account_id')) ||
        (data.last_day === undefined && (missing0 = 'last_day')) ||
        (data.range === undefined && (missing0 = 'range')) ||
        (data.total === undefined && (missing0 = 'total'))
      ) {
        validate23.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.account_id !== undefined) {
          const _errs1 = errors;
          if (typeof data.account_id !== 'string') {
            validate23.errors = [
              {
                instancePath: instancePath + '/account_id',
                schemaPath: '#/properties/account_id/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.items !== undefined) {
            let data1 = data.items;
            const _errs3 = errors;
            if (errors === _errs3) {
              if (Array.isArray(data1)) {
                var valid1 = true;
                const len0 = data1.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  let data2 = data1[i0];
                  const _errs5 = errors;
                  if (
                    data2 &&
                    typeof data2 == 'object' &&
                    !Array.isArray(data2)
                  ) {
                    let missing1;
                    if (
                      (data2.count === undefined && (missing1 = 'count')) ||
                      (data2.date === undefined && (missing1 = 'date'))
                    ) {
                      validate23.errors = [
                        {
                          instancePath: instancePath + '/items/' + i0,
                          schemaPath: '#/properties/items/items/required',
                          keyword: 'required',
                          params: { missingProperty: missing1 },
                          message:
                            "must have required property '" + missing1 + "'",
                        },
                      ];
                      return false;
                    } else {
                      if (data2.count !== undefined) {
                        let data3 = data2.count;
                        const _errs6 = errors;
                        if (!(typeof data3 == 'number' && isFinite(data3))) {
                          validate23.errors = [
                            {
                              instancePath:
                                instancePath + '/items/' + i0 + '/count',
                              schemaPath:
                                '#/properties/items/items/properties/count/type',
                              keyword: 'type',
                              params: { type: 'number' },
                              message: 'must be number',
                            },
                          ];
                          return false;
                        }
                        var valid2 = _errs6 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data2.date !== undefined) {
                          const _errs8 = errors;
                          if (typeof data2.date !== 'string') {
                            validate23.errors = [
                              {
                                instancePath:
                                  instancePath + '/items/' + i0 + '/date',
                                schemaPath:
                                  '#/properties/items/items/properties/date/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid2 = _errs8 === errors;
                        } else {
                          var valid2 = true;
                        }
                      }
                    }
                  }
                  var valid1 = _errs5 === errors;
                  if (!valid1) {
                    break;
                  }
                }
              } else {
                validate23.errors = [
                  {
                    instancePath: instancePath + '/items',
                    schemaPath: '#/properties/items/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                  },
                ];
                return false;
              }
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.last_day !== undefined) {
              let data5 = data.last_day;
              const _errs10 = errors;
              if (!(typeof data5 == 'number' && isFinite(data5))) {
                validate23.errors = [
                  {
                    instancePath: instancePath + '/last_day',
                    schemaPath: '#/properties/last_day/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                  },
                ];
                return false;
              }
              var valid0 = _errs10 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.range !== undefined) {
                const _errs12 = errors;
                if (typeof data.range !== 'string') {
                  validate23.errors = [
                    {
                      instancePath: instancePath + '/range',
                      schemaPath: '#/properties/range/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs12 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.total !== undefined) {
                  let data7 = data.total;
                  const _errs14 = errors;
                  if (!(typeof data7 == 'number' && isFinite(data7))) {
                    validate23.errors = [
                      {
                        instancePath: instancePath + '/total',
                        schemaPath: '#/properties/total/type',
                        keyword: 'type',
                        params: { type: 'number' },
                        message: 'must be number',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs14 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate23.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate23.errors = vErrors;
  return errors === 0;
}
exports.validateSignatureRequestUsageData = validate24;
function validate24(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="SignatureRequestUsageData.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.x === undefined && (missing0 = 'x')) ||
        (data.y === undefined && (missing0 = 'y'))
      ) {
        validate24.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.x !== undefined) {
          let data0 = data.x;
          const _errs1 = errors;
          if (errors === _errs1) {
            if (Array.isArray(data0)) {
              var valid1 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                const _errs3 = errors;
                if (typeof data0[i0] !== 'string') {
                  validate24.errors = [
                    {
                      instancePath: instancePath + '/x/' + i0,
                      schemaPath: '#/properties/x/items/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid1 = _errs3 === errors;
                if (!valid1) {
                  break;
                }
              }
            } else {
              validate24.errors = [
                {
                  instancePath: instancePath + '/x',
                  schemaPath: '#/properties/x/type',
                  keyword: 'type',
                  params: { type: 'array' },
                  message: 'must be array',
                },
              ];
              return false;
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.y !== undefined) {
            let data2 = data.y;
            const _errs5 = errors;
            if (errors === _errs5) {
              if (Array.isArray(data2)) {
                var valid2 = true;
                const len1 = data2.length;
                for (let i1 = 0; i1 < len1; i1++) {
                  let data3 = data2[i1];
                  const _errs7 = errors;
                  if (!(typeof data3 == 'number' && isFinite(data3))) {
                    validate24.errors = [
                      {
                        instancePath: instancePath + '/y/' + i1,
                        schemaPath: '#/properties/y/items/type',
                        keyword: 'type',
                        params: { type: 'number' },
                        message: 'must be number',
                      },
                    ];
                    return false;
                  }
                  var valid2 = _errs7 === errors;
                  if (!valid2) {
                    break;
                  }
                }
              } else {
                validate24.errors = [
                  {
                    instancePath: instancePath + '/y',
                    schemaPath: '#/properties/y/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                  },
                ];
                return false;
              }
            }
            var valid0 = _errs5 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.client_ids !== undefined) {
              let data4 = data.client_ids;
              const _errs9 = errors;
              if (errors === _errs9) {
                if (Array.isArray(data4)) {
                  var valid3 = true;
                  const len2 = data4.length;
                  for (let i2 = 0; i2 < len2; i2++) {
                    const _errs11 = errors;
                    if (typeof data4[i2] !== 'string') {
                      validate24.errors = [
                        {
                          instancePath: instancePath + '/client_ids/' + i2,
                          schemaPath: '#/properties/client_ids/items/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                    var valid3 = _errs11 === errors;
                    if (!valid3) {
                      break;
                    }
                  }
                } else {
                  validate24.errors = [
                    {
                      instancePath: instancePath + '/client_ids',
                      schemaPath: '#/properties/client_ids/type',
                      keyword: 'type',
                      params: { type: 'array' },
                      message: 'must be array',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs9 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate24.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate24.errors = vErrors;
  return errors === 0;
}
exports.validateSignatureRequestStatusData = validate11;
exports.validateNameYDataSet = validate25;
function validate25(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="NameYDataSet.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.name === undefined && (missing0 = 'name')) ||
        (data.y === undefined && (missing0 = 'y'))
      ) {
        validate25.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.name !== undefined) {
          const _errs1 = errors;
          if (typeof data.name !== 'string') {
            validate25.errors = [
              {
                instancePath: instancePath + '/name',
                schemaPath: '#/properties/name/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.y !== undefined) {
            let data1 = data.y;
            const _errs3 = errors;
            if (!(typeof data1 == 'number' && isFinite(data1))) {
              validate25.errors = [
                {
                  instancePath: instancePath + '/y',
                  schemaPath: '#/properties/y/type',
                  keyword: 'type',
                  params: { type: 'number' },
                  message: 'must be number',
                },
              ];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate25.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate25.errors = vErrors;
  return errors === 0;
}
exports.validateAPIAccountData = validate26;
function validate26(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="APIAccountData.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (data.timezone_info === undefined && (missing0 = 'timezone_info')) {
        validate26.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.account_id !== undefined) {
          const _errs1 = errors;
          if (typeof data.account_id !== 'string') {
            validate26.errors = [
              {
                instancePath: instancePath + '/account_id',
                schemaPath: '#/properties/account_id/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.emailAddress !== undefined) {
            const _errs3 = errors;
            if (typeof data.emailAddress !== 'string') {
              validate26.errors = [
                {
                  instancePath: instancePath + '/emailAddress',
                  schemaPath: '#/properties/emailAddress/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.timezone_info !== undefined) {
              let data2 = data.timezone_info;
              const _errs5 = errors;
              if (errors === _errs5) {
                if (
                  data2 &&
                  typeof data2 == 'object' &&
                  !Array.isArray(data2)
                ) {
                  if (data2.abbreviation !== undefined) {
                    const _errs7 = errors;
                    if (typeof data2.abbreviation !== 'string') {
                      validate26.errors = [
                        {
                          instancePath:
                            instancePath + '/timezone_info/abbreviation',
                          schemaPath:
                            '#/properties/timezone_info/properties/abbreviation/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                    var valid1 = _errs7 === errors;
                  } else {
                    var valid1 = true;
                  }
                  if (valid1) {
                    if (data2.display_name !== undefined) {
                      const _errs9 = errors;
                      if (typeof data2.display_name !== 'string') {
                        validate26.errors = [
                          {
                            instancePath:
                              instancePath + '/timezone_info/display_name',
                            schemaPath:
                              '#/properties/timezone_info/properties/display_name/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid1 = _errs9 === errors;
                    } else {
                      var valid1 = true;
                    }
                    if (valid1) {
                      if (data2.gmt_offset !== undefined) {
                        let data5 = data2.gmt_offset;
                        const _errs11 = errors;
                        if (!(typeof data5 == 'number' && isFinite(data5))) {
                          validate26.errors = [
                            {
                              instancePath:
                                instancePath + '/timezone_info/gmt_offset',
                              schemaPath:
                                '#/properties/timezone_info/properties/gmt_offset/type',
                              keyword: 'type',
                              params: { type: 'number' },
                              message: 'must be number',
                            },
                          ];
                          return false;
                        }
                        var valid1 = _errs11 === errors;
                      } else {
                        var valid1 = true;
                      }
                      if (valid1) {
                        if (data2.has_dst !== undefined) {
                          let data6 = data2.has_dst;
                          const _errs13 = errors;
                          if (!(typeof data6 == 'number' && isFinite(data6))) {
                            validate26.errors = [
                              {
                                instancePath:
                                  instancePath + '/timezone_info/has_dst',
                                schemaPath:
                                  '#/properties/timezone_info/properties/has_dst/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number',
                              },
                            ];
                            return false;
                          }
                          var valid1 = _errs13 === errors;
                        } else {
                          var valid1 = true;
                        }
                        if (valid1) {
                          if (data2.matching_identifier !== undefined) {
                            const _errs15 = errors;
                            if (typeof data2.matching_identifier !== 'string') {
                              validate26.errors = [
                                {
                                  instancePath:
                                    instancePath +
                                    '/timezone_info/matching_identifier',
                                  schemaPath:
                                    '#/properties/timezone_info/properties/matching_identifier/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                },
                              ];
                              return false;
                            }
                            var valid1 = _errs15 === errors;
                          } else {
                            var valid1 = true;
                          }
                        }
                      }
                    }
                  }
                } else {
                  validate26.errors = [
                    {
                      instancePath: instancePath + '/timezone_info',
                      schemaPath: '#/properties/timezone_info/type',
                      keyword: 'type',
                      params: { type: 'object' },
                      message: 'must be object',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.billing !== undefined) {
                let data8 = data.billing;
                const _errs17 = errors;
                if (errors === _errs17) {
                  if (
                    data8 &&
                    typeof data8 == 'object' &&
                    !Array.isArray(data8)
                  ) {
                    if (data8.next_refresh_date !== undefined) {
                      let data9 = data8.next_refresh_date;
                      const _errs19 = errors;
                      if (typeof data9 !== 'string' && data9 !== null) {
                        validate26.errors = [
                          {
                            instancePath:
                              instancePath + '/billing/next_refresh_date',
                            schemaPath:
                              '#/properties/billing/properties/next_refresh_date/type',
                            keyword: 'type',
                            params: {
                              type: schema17.properties.billing.properties
                                .next_refresh_date.type,
                            },
                            message: 'must be string,null',
                          },
                        ];
                        return false;
                      }
                      var valid2 = _errs19 === errors;
                    } else {
                      var valid2 = true;
                    }
                    if (valid2) {
                      if (data8.next_billing_date !== undefined) {
                        let data10 = data8.next_billing_date;
                        const _errs21 = errors;
                        if (typeof data10 !== 'string' && data10 !== null) {
                          validate26.errors = [
                            {
                              instancePath:
                                instancePath + '/billing/next_billing_date',
                              schemaPath:
                                '#/properties/billing/properties/next_billing_date/type',
                              keyword: 'type',
                              params: {
                                type: schema17.properties.billing.properties
                                  .next_billing_date.type,
                              },
                              message: 'must be string,null',
                            },
                          ];
                          return false;
                        }
                        var valid2 = _errs21 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data8.plan_name !== undefined) {
                          const _errs23 = errors;
                          if (typeof data8.plan_name !== 'string') {
                            validate26.errors = [
                              {
                                instancePath:
                                  instancePath + '/billing/plan_name',
                                schemaPath:
                                  '#/properties/billing/properties/plan_name/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid2 = _errs23 === errors;
                        } else {
                          var valid2 = true;
                        }
                      }
                    }
                  } else {
                    validate26.errors = [
                      {
                        instancePath: instancePath + '/billing',
                        schemaPath: '#/properties/billing/type',
                        keyword: 'type',
                        params: { type: 'object' },
                        message: 'must be object',
                      },
                    ];
                    return false;
                  }
                }
                var valid0 = _errs17 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.quotas !== undefined) {
                  let data12 = data.quotas;
                  const _errs25 = errors;
                  if (errors === _errs25) {
                    if (
                      data12 &&
                      typeof data12 == 'object' &&
                      !Array.isArray(data12)
                    ) {
                      if (data12.templates_left !== undefined) {
                        let data13 = data12.templates_left;
                        const _errs27 = errors;
                        if (
                          !(typeof data13 == 'number' && isFinite(data13)) &&
                          data13 !== null
                        ) {
                          validate26.errors = [
                            {
                              instancePath:
                                instancePath + '/quotas/templates_left',
                              schemaPath:
                                '#/properties/quotas/properties/templates_left/type',
                              keyword: 'type',
                              params: {
                                type: schema17.properties.quotas.properties
                                  .templates_left.type,
                              },
                              message: 'must be number,null',
                            },
                          ];
                          return false;
                        }
                        var valid3 = _errs27 === errors;
                      } else {
                        var valid3 = true;
                      }
                      if (valid3) {
                        if (data12.documents_left !== undefined) {
                          let data14 = data12.documents_left;
                          const _errs29 = errors;
                          if (
                            !(typeof data14 == 'number' && isFinite(data14)) &&
                            data14 !== null
                          ) {
                            validate26.errors = [
                              {
                                instancePath:
                                  instancePath + '/quotas/documents_left',
                                schemaPath:
                                  '#/properties/quotas/properties/documents_left/type',
                                keyword: 'type',
                                params: {
                                  type: schema17.properties.quotas.properties
                                    .documents_left.type,
                                },
                                message: 'must be number,null',
                              },
                            ];
                            return false;
                          }
                          var valid3 = _errs29 === errors;
                        } else {
                          var valid3 = true;
                        }
                        if (valid3) {
                          if (
                            data12.api_signature_requests_left !== undefined
                          ) {
                            let data15 = data12.api_signature_requests_left;
                            const _errs31 = errors;
                            if (
                              !(
                                typeof data15 == 'number' && isFinite(data15)
                              ) &&
                              data15 !== null
                            ) {
                              validate26.errors = [
                                {
                                  instancePath:
                                    instancePath +
                                    '/quotas/api_signature_requests_left',
                                  schemaPath:
                                    '#/properties/quotas/properties/api_signature_requests_left/type',
                                  keyword: 'type',
                                  params: {
                                    type: schema17.properties.quotas.properties
                                      .api_signature_requests_left.type,
                                  },
                                  message: 'must be number,null',
                                },
                              ];
                              return false;
                            }
                            var valid3 = _errs31 === errors;
                          } else {
                            var valid3 = true;
                          }
                          if (valid3) {
                            if (
                              data12.all_signature_requests_left !== undefined
                            ) {
                              let data16 = data12.all_signature_requests_left;
                              const _errs33 = errors;
                              if (
                                !(
                                  typeof data16 == 'number' && isFinite(data16)
                                ) &&
                                data16 !== null
                              ) {
                                validate26.errors = [
                                  {
                                    instancePath:
                                      instancePath +
                                      '/quotas/all_signature_requests_left',
                                    schemaPath:
                                      '#/properties/quotas/properties/all_signature_requests_left/type',
                                    keyword: 'type',
                                    params: {
                                      type: schema17.properties.quotas
                                        .properties.all_signature_requests_left
                                        .type,
                                    },
                                    message: 'must be number,null',
                                  },
                                ];
                                return false;
                              }
                              var valid3 = _errs33 === errors;
                            } else {
                              var valid3 = true;
                            }
                            if (valid3) {
                              if (
                                data12.all_signature_requests_total !==
                                undefined
                              ) {
                                let data17 =
                                  data12.all_signature_requests_total;
                                const _errs35 = errors;
                                if (
                                  !(
                                    typeof data17 == 'number' &&
                                    isFinite(data17)
                                  ) &&
                                  data17 !== null
                                ) {
                                  validate26.errors = [
                                    {
                                      instancePath:
                                        instancePath +
                                        '/quotas/all_signature_requests_total',
                                      schemaPath:
                                        '#/properties/quotas/properties/all_signature_requests_total/type',
                                      keyword: 'type',
                                      params: {
                                        type: schema17.properties.quotas
                                          .properties
                                          .all_signature_requests_total.type,
                                      },
                                      message: 'must be number,null',
                                    },
                                  ];
                                  return false;
                                }
                                var valid3 = _errs35 === errors;
                              } else {
                                var valid3 = true;
                              }
                              if (valid3) {
                                if (data12.templates_total !== undefined) {
                                  let data18 = data12.templates_total;
                                  const _errs37 = errors;
                                  if (
                                    !(
                                      typeof data18 == 'number' &&
                                      isFinite(data18)
                                    ) &&
                                    data18 !== null
                                  ) {
                                    validate26.errors = [
                                      {
                                        instancePath:
                                          instancePath +
                                          '/quotas/templates_total',
                                        schemaPath:
                                          '#/properties/quotas/properties/templates_total/type',
                                        keyword: 'type',
                                        params: {
                                          type: schema17.properties.quotas
                                            .properties.templates_total.type,
                                        },
                                        message: 'must be number,null',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid3 = _errs37 === errors;
                                } else {
                                  var valid3 = true;
                                }
                                if (valid3) {
                                  if (
                                    data12.sms_verifications_left !== undefined
                                  ) {
                                    let data19 = data12.sms_verifications_left;
                                    const _errs39 = errors;
                                    if (
                                      !(
                                        typeof data19 == 'number' &&
                                        isFinite(data19)
                                      ) &&
                                      data19 !== null
                                    ) {
                                      validate26.errors = [
                                        {
                                          instancePath:
                                            instancePath +
                                            '/quotas/sms_verifications_left',
                                          schemaPath:
                                            '#/properties/quotas/properties/sms_verifications_left/type',
                                          keyword: 'type',
                                          params: {
                                            type: schema17.properties.quotas
                                              .properties.sms_verifications_left
                                              .type,
                                          },
                                          message: 'must be number,null',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid3 = _errs39 === errors;
                                  } else {
                                    var valid3 = true;
                                  }
                                  if (valid3) {
                                    if (
                                      data12.sms_verifications_total !==
                                      undefined
                                    ) {
                                      let data20 =
                                        data12.sms_verifications_total;
                                      const _errs41 = errors;
                                      if (
                                        !(
                                          typeof data20 == 'number' &&
                                          isFinite(data20)
                                        ) &&
                                        data20 !== null
                                      ) {
                                        validate26.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/quotas/sms_verifications_total',
                                            schemaPath:
                                              '#/properties/quotas/properties/sms_verifications_total/type',
                                            keyword: 'type',
                                            params: {
                                              type: schema17.properties.quotas
                                                .properties
                                                .sms_verifications_total.type,
                                            },
                                            message: 'must be number,null',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid3 = _errs41 === errors;
                                    } else {
                                      var valid3 = true;
                                    }
                                    if (valid3) {
                                      if (
                                        data12.api_signature_requests_used !==
                                        undefined
                                      ) {
                                        let data21 =
                                          data12.api_signature_requests_used;
                                        const _errs43 = errors;
                                        if (
                                          !(
                                            typeof data21 == 'number' &&
                                            isFinite(data21)
                                          ) &&
                                          data21 !== null
                                        ) {
                                          validate26.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/quotas/api_signature_requests_used',
                                              schemaPath:
                                                '#/properties/quotas/properties/api_signature_requests_used/type',
                                              keyword: 'type',
                                              params: {
                                                type: schema17.properties.quotas
                                                  .properties
                                                  .api_signature_requests_used
                                                  .type,
                                              },
                                              message: 'must be number,null',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid3 = _errs43 === errors;
                                      } else {
                                        var valid3 = true;
                                      }
                                      if (valid3) {
                                        if (
                                          data12.api_signature_requests_total !==
                                          undefined
                                        ) {
                                          let data22 =
                                            data12.api_signature_requests_total;
                                          const _errs45 = errors;
                                          if (
                                            !(
                                              typeof data22 == 'number' &&
                                              isFinite(data22)
                                            ) &&
                                            data22 !== null
                                          ) {
                                            validate26.errors = [
                                              {
                                                instancePath:
                                                  instancePath +
                                                  '/quotas/api_signature_requests_total',
                                                schemaPath:
                                                  '#/properties/quotas/properties/api_signature_requests_total/type',
                                                keyword: 'type',
                                                params: {
                                                  type: schema17.properties
                                                    .quotas.properties
                                                    .api_signature_requests_total
                                                    .type,
                                                },
                                                message: 'must be number,null',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid3 = _errs45 === errors;
                                        } else {
                                          var valid3 = true;
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    } else {
                      validate26.errors = [
                        {
                          instancePath: instancePath + '/quotas',
                          schemaPath: '#/properties/quotas/type',
                          keyword: 'type',
                          params: { type: 'object' },
                          message: 'must be object',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid0 = _errs25 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate26.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate26.errors = vErrors;
  return errors === 0;
}
exports.validateAPICallbacksData = validate27;
function validate27(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="APICallbacksData.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.count === undefined && (missing0 = 'count')) ||
        (data.page_size === undefined && (missing0 = 'page_size'))
      ) {
        validate27.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.items !== undefined) {
          let data0 = data.items;
          const _errs1 = errors;
          if (errors === _errs1) {
            if (Array.isArray(data0)) {
              var valid1 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                let data1 = data0[i0];
                const _errs3 = errors;
                if (
                  data1 &&
                  typeof data1 == 'object' &&
                  !Array.isArray(data1)
                ) {
                  let missing1;
                  if (
                    (data1.id === undefined && (missing1 = 'id')) ||
                    (data1.received === undefined && (missing1 = 'received')) ||
                    (data1.timestamp === undefined &&
                      (missing1 = 'timestamp')) ||
                    (data1.type === undefined && (missing1 = 'type'))
                  ) {
                    validate27.errors = [
                      {
                        instancePath: instancePath + '/items/' + i0,
                        schemaPath: '#/properties/items/items/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message:
                          "must have required property '" + missing1 + "'",
                      },
                    ];
                    return false;
                  } else {
                    if (data1.id !== undefined) {
                      const _errs4 = errors;
                      if (typeof data1.id !== 'string') {
                        validate27.errors = [
                          {
                            instancePath: instancePath + '/items/' + i0 + '/id',
                            schemaPath:
                              '#/properties/items/items/properties/id/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid2 = _errs4 === errors;
                    } else {
                      var valid2 = true;
                    }
                    if (valid2) {
                      if (data1.received !== undefined) {
                        const _errs6 = errors;
                        if (typeof data1.received !== 'boolean') {
                          validate27.errors = [
                            {
                              instancePath:
                                instancePath + '/items/' + i0 + '/received',
                              schemaPath:
                                '#/properties/items/items/properties/received/type',
                              keyword: 'type',
                              params: { type: 'boolean' },
                              message: 'must be boolean',
                            },
                          ];
                          return false;
                        }
                        var valid2 = _errs6 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data1.timestamp !== undefined) {
                          let data4 = data1.timestamp;
                          const _errs8 = errors;
                          if (!(typeof data4 == 'number' && isFinite(data4))) {
                            validate27.errors = [
                              {
                                instancePath:
                                  instancePath + '/items/' + i0 + '/timestamp',
                                schemaPath:
                                  '#/properties/items/items/properties/timestamp/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number',
                              },
                            ];
                            return false;
                          }
                          var valid2 = _errs8 === errors;
                        } else {
                          var valid2 = true;
                        }
                        if (valid2) {
                          if (data1.type !== undefined) {
                            const _errs10 = errors;
                            if (typeof data1.type !== 'string') {
                              validate27.errors = [
                                {
                                  instancePath:
                                    instancePath + '/items/' + i0 + '/type',
                                  schemaPath:
                                    '#/properties/items/items/properties/type/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                },
                              ];
                              return false;
                            }
                            var valid2 = _errs10 === errors;
                          } else {
                            var valid2 = true;
                          }
                        }
                      }
                    }
                  }
                }
                var valid1 = _errs3 === errors;
                if (!valid1) {
                  break;
                }
              }
            } else {
              validate27.errors = [
                {
                  instancePath: instancePath + '/items',
                  schemaPath: '#/properties/items/type',
                  keyword: 'type',
                  params: { type: 'array' },
                  message: 'must be array',
                },
              ];
              return false;
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.count !== undefined) {
            let data6 = data.count;
            const _errs12 = errors;
            if (!(typeof data6 == 'number' && isFinite(data6))) {
              validate27.errors = [
                {
                  instancePath: instancePath + '/count',
                  schemaPath: '#/properties/count/type',
                  keyword: 'type',
                  params: { type: 'number' },
                  message: 'must be number',
                },
              ];
              return false;
            }
            var valid0 = _errs12 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.page_size !== undefined) {
              let data7 = data.page_size;
              const _errs14 = errors;
              if (!(typeof data7 == 'number' && isFinite(data7))) {
                validate27.errors = [
                  {
                    instancePath: instancePath + '/page_size',
                    schemaPath: '#/properties/page_size/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                  },
                ];
                return false;
              }
              var valid0 = _errs14 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate27.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate27.errors = vErrors;
  return errors === 0;
}
exports.validateAPIRequestsData = validate28;
function validate28(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="APIRequestsData.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.count === undefined && (missing0 = 'count')) ||
        (data.page_size === undefined && (missing0 = 'page_size'))
      ) {
        validate28.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.items !== undefined) {
          let data0 = data.items;
          const _errs1 = errors;
          if (errors === _errs1) {
            if (Array.isArray(data0)) {
              var valid1 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                let data1 = data0[i0];
                const _errs3 = errors;
                if (
                  data1 &&
                  typeof data1 == 'object' &&
                  !Array.isArray(data1)
                ) {
                  let missing1;
                  if (
                    (data1.id === undefined && (missing1 = 'id')) ||
                    (data1.method === undefined && (missing1 = 'method')) ||
                    (data1.path === undefined && (missing1 = 'path')) ||
                    (data1.status === undefined && (missing1 = 'status')) ||
                    (data1.timestamp === undefined && (missing1 = 'timestamp'))
                  ) {
                    validate28.errors = [
                      {
                        instancePath: instancePath + '/items/' + i0,
                        schemaPath: '#/properties/items/items/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message:
                          "must have required property '" + missing1 + "'",
                      },
                    ];
                    return false;
                  } else {
                    if (data1.id !== undefined) {
                      const _errs4 = errors;
                      if (typeof data1.id !== 'string') {
                        validate28.errors = [
                          {
                            instancePath: instancePath + '/items/' + i0 + '/id',
                            schemaPath:
                              '#/properties/items/items/properties/id/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid2 = _errs4 === errors;
                    } else {
                      var valid2 = true;
                    }
                    if (valid2) {
                      if (data1.method !== undefined) {
                        const _errs6 = errors;
                        if (typeof data1.method !== 'string') {
                          validate28.errors = [
                            {
                              instancePath:
                                instancePath + '/items/' + i0 + '/method',
                              schemaPath:
                                '#/properties/items/items/properties/method/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid2 = _errs6 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data1.path !== undefined) {
                          const _errs8 = errors;
                          if (typeof data1.path !== 'string') {
                            validate28.errors = [
                              {
                                instancePath:
                                  instancePath + '/items/' + i0 + '/path',
                                schemaPath:
                                  '#/properties/items/items/properties/path/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid2 = _errs8 === errors;
                        } else {
                          var valid2 = true;
                        }
                        if (valid2) {
                          if (data1.status !== undefined) {
                            let data5 = data1.status;
                            const _errs10 = errors;
                            if (
                              !(typeof data5 == 'number' && isFinite(data5))
                            ) {
                              validate28.errors = [
                                {
                                  instancePath:
                                    instancePath + '/items/' + i0 + '/status',
                                  schemaPath:
                                    '#/properties/items/items/properties/status/type',
                                  keyword: 'type',
                                  params: { type: 'number' },
                                  message: 'must be number',
                                },
                              ];
                              return false;
                            }
                            var valid2 = _errs10 === errors;
                          } else {
                            var valid2 = true;
                          }
                          if (valid2) {
                            if (data1.timestamp !== undefined) {
                              let data6 = data1.timestamp;
                              const _errs12 = errors;
                              if (
                                !(typeof data6 == 'number' && isFinite(data6))
                              ) {
                                validate28.errors = [
                                  {
                                    instancePath:
                                      instancePath +
                                      '/items/' +
                                      i0 +
                                      '/timestamp',
                                    schemaPath:
                                      '#/properties/items/items/properties/timestamp/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number',
                                  },
                                ];
                                return false;
                              }
                              var valid2 = _errs12 === errors;
                            } else {
                              var valid2 = true;
                            }
                          }
                        }
                      }
                    }
                  }
                }
                var valid1 = _errs3 === errors;
                if (!valid1) {
                  break;
                }
              }
            } else {
              validate28.errors = [
                {
                  instancePath: instancePath + '/items',
                  schemaPath: '#/properties/items/type',
                  keyword: 'type',
                  params: { type: 'array' },
                  message: 'must be array',
                },
              ];
              return false;
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.count !== undefined) {
            let data7 = data.count;
            const _errs14 = errors;
            if (!(typeof data7 == 'number' && isFinite(data7))) {
              validate28.errors = [
                {
                  instancePath: instancePath + '/count',
                  schemaPath: '#/properties/count/type',
                  keyword: 'type',
                  params: { type: 'number' },
                  message: 'must be number',
                },
              ];
              return false;
            }
            var valid0 = _errs14 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.page_size !== undefined) {
              let data8 = data.page_size;
              const _errs16 = errors;
              if (!(typeof data8 == 'number' && isFinite(data8))) {
                validate28.errors = [
                  {
                    instancePath: instancePath + '/page_size',
                    schemaPath: '#/properties/page_size/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                  },
                ];
                return false;
              }
              var valid0 = _errs16 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate28.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate28.errors = vErrors;
  return errors === 0;
}
exports.validateAPICallbackData = validate29;
function validate29(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="APICallbackData.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.event_data === undefined && (missing0 = 'event_data')) ||
        (data.id === undefined && (missing0 = 'id')) ||
        (data.timestamp === undefined && (missing0 = 'timestamp')) ||
        (data.type === undefined && (missing0 = 'type'))
      ) {
        validate29.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.attempts !== undefined) {
          let data0 = data.attempts;
          const _errs1 = errors;
          if (errors === _errs1) {
            if (Array.isArray(data0)) {
              var valid1 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                let data1 = data0[i0];
                const _errs3 = errors;
                if (
                  data1 &&
                  typeof data1 == 'object' &&
                  !Array.isArray(data1)
                ) {
                  let missing1;
                  if (
                    (data1.error === undefined && (missing1 = 'error')) ||
                    (data1.status_code === undefined &&
                      (missing1 = 'status_code')) ||
                    (data1.response === undefined && (missing1 = 'response')) ||
                    (data1.success === undefined && (missing1 = 'success')) ||
                    (data1.timestamp === undefined &&
                      (missing1 = 'timestamp')) ||
                    (data1.url === undefined && (missing1 = 'url'))
                  ) {
                    validate29.errors = [
                      {
                        instancePath: instancePath + '/attempts/' + i0,
                        schemaPath: '#/properties/attempts/items/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message:
                          "must have required property '" + missing1 + "'",
                      },
                    ];
                    return false;
                  } else {
                    if (data1.error !== undefined) {
                      let data2 = data1.error;
                      const _errs4 = errors;
                      if (typeof data2 !== 'string' && data2 !== null) {
                        validate29.errors = [
                          {
                            instancePath:
                              instancePath + '/attempts/' + i0 + '/error',
                            schemaPath:
                              '#/properties/attempts/items/properties/error/type',
                            keyword: 'type',
                            params: {
                              type: schema20.properties.attempts.items
                                .properties.error.type,
                            },
                            message: 'must be string,null',
                          },
                        ];
                        return false;
                      }
                      var valid2 = _errs4 === errors;
                    } else {
                      var valid2 = true;
                    }
                    if (valid2) {
                      if (data1.url !== undefined) {
                        let data3 = data1.url;
                        const _errs6 = errors;
                        if (typeof data3 !== 'string' && data3 !== null) {
                          validate29.errors = [
                            {
                              instancePath:
                                instancePath + '/attempts/' + i0 + '/url',
                              schemaPath:
                                '#/properties/attempts/items/properties/url/type',
                              keyword: 'type',
                              params: {
                                type: schema20.properties.attempts.items
                                  .properties.url.type,
                              },
                              message: 'must be string,null',
                            },
                          ];
                          return false;
                        }
                        var valid2 = _errs6 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data1.status_code !== undefined) {
                          let data4 = data1.status_code;
                          const _errs8 = errors;
                          if (
                            !(typeof data4 == 'number' && isFinite(data4)) &&
                            data4 !== null
                          ) {
                            validate29.errors = [
                              {
                                instancePath:
                                  instancePath +
                                  '/attempts/' +
                                  i0 +
                                  '/status_code',
                                schemaPath:
                                  '#/properties/attempts/items/properties/status_code/type',
                                keyword: 'type',
                                params: {
                                  type: schema20.properties.attempts.items
                                    .properties.status_code.type,
                                },
                                message: 'must be number,null',
                              },
                            ];
                            return false;
                          }
                          var valid2 = _errs8 === errors;
                        } else {
                          var valid2 = true;
                        }
                        if (valid2) {
                          if (data1.response !== undefined) {
                            let data5 = data1.response;
                            const _errs10 = errors;
                            if (typeof data5 !== 'string' && data5 !== null) {
                              validate29.errors = [
                                {
                                  instancePath:
                                    instancePath +
                                    '/attempts/' +
                                    i0 +
                                    '/response',
                                  schemaPath:
                                    '#/properties/attempts/items/properties/response/type',
                                  keyword: 'type',
                                  params: {
                                    type: schema20.properties.attempts.items
                                      .properties.response.type,
                                  },
                                  message: 'must be string,null',
                                },
                              ];
                              return false;
                            }
                            var valid2 = _errs10 === errors;
                          } else {
                            var valid2 = true;
                          }
                          if (valid2) {
                            if (data1.success !== undefined) {
                              const _errs12 = errors;
                              if (typeof data1.success !== 'boolean') {
                                validate29.errors = [
                                  {
                                    instancePath:
                                      instancePath +
                                      '/attempts/' +
                                      i0 +
                                      '/success',
                                    schemaPath:
                                      '#/properties/attempts/items/properties/success/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean',
                                  },
                                ];
                                return false;
                              }
                              var valid2 = _errs12 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (data1.timestamp !== undefined) {
                                let data7 = data1.timestamp;
                                const _errs14 = errors;
                                if (
                                  !(typeof data7 == 'number' && isFinite(data7))
                                ) {
                                  validate29.errors = [
                                    {
                                      instancePath:
                                        instancePath +
                                        '/attempts/' +
                                        i0 +
                                        '/timestamp',
                                      schemaPath:
                                        '#/properties/attempts/items/properties/timestamp/type',
                                      keyword: 'type',
                                      params: { type: 'number' },
                                      message: 'must be number',
                                    },
                                  ];
                                  return false;
                                }
                                var valid2 = _errs14 === errors;
                              } else {
                                var valid2 = true;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
                var valid1 = _errs3 === errors;
                if (!valid1) {
                  break;
                }
              }
            } else {
              validate29.errors = [
                {
                  instancePath: instancePath + '/attempts',
                  schemaPath: '#/properties/attempts/type',
                  keyword: 'type',
                  params: { type: 'array' },
                  message: 'must be array',
                },
              ];
              return false;
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.event_data !== undefined) {
            let data8 = data.event_data;
            const _errs16 = errors;
            if (typeof data8 !== 'string' && data8 !== null) {
              validate29.errors = [
                {
                  instancePath: instancePath + '/event_data',
                  schemaPath: '#/properties/event_data/type',
                  keyword: 'type',
                  params: { type: schema20.properties.event_data.type },
                  message: 'must be string,null',
                },
              ];
              return false;
            }
            var valid0 = _errs16 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.id !== undefined) {
              let data9 = data.id;
              const _errs18 = errors;
              if (typeof data9 !== 'string' && data9 !== null) {
                validate29.errors = [
                  {
                    instancePath: instancePath + '/id',
                    schemaPath: '#/properties/id/type',
                    keyword: 'type',
                    params: { type: schema20.properties.id.type },
                    message: 'must be string,null',
                  },
                ];
                return false;
              }
              var valid0 = _errs18 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.timestamp !== undefined) {
                let data10 = data.timestamp;
                const _errs20 = errors;
                if (!(typeof data10 == 'number' && isFinite(data10))) {
                  validate29.errors = [
                    {
                      instancePath: instancePath + '/timestamp',
                      schemaPath: '#/properties/timestamp/type',
                      keyword: 'type',
                      params: { type: 'number' },
                      message: 'must be number',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs20 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.type !== undefined) {
                  let data11 = data.type;
                  const _errs22 = errors;
                  if (typeof data11 !== 'string' && data11 !== null) {
                    validate29.errors = [
                      {
                        instancePath: instancePath + '/type',
                        schemaPath: '#/properties/type/type',
                        keyword: 'type',
                        params: { type: schema20.properties.type.type },
                        message: 'must be string,null',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs22 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate29.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate29.errors = vErrors;
  return errors === 0;
}
exports.validateAPIEventTypesData = validate30;
function validate30(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="APIEventTypesData.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (Array.isArray(data)) {
      var valid0 = true;
      const len0 = data.length;
      for (let i0 = 0; i0 < len0; i0++) {
        const _errs1 = errors;
        if (typeof data[i0] !== 'string') {
          validate30.errors = [
            {
              instancePath: instancePath + '/' + i0,
              schemaPath: '#/items/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
            },
          ];
          return false;
        }
        var valid0 = _errs1 === errors;
        if (!valid0) {
          break;
        }
      }
    } else {
      validate30.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'array' },
          message: 'must be array',
        },
      ];
      return false;
    }
  }
  validate30.errors = vErrors;
  return errors === 0;
}
exports.validateAPIRequestsHTTPStatusData = validate13;
exports.validateAPIEndpointListData = validate31;
function validate31(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="APIEndpointListData.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (Array.isArray(data)) {
      var valid0 = true;
      const len0 = data.length;
      for (let i0 = 0; i0 < len0; i0++) {
        let data0 = data[i0];
        const _errs1 = errors;
        if (errors === _errs1) {
          if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
            let missing0;
            if (
              (data0.key === undefined && (missing0 = 'key')) ||
              (data0.value === undefined && (missing0 = 'value')) ||
              (data0.isSelected === undefined && (missing0 = 'isSelected'))
            ) {
              validate31.errors = [
                {
                  instancePath: instancePath + '/' + i0,
                  schemaPath: '#/items/required',
                  keyword: 'required',
                  params: { missingProperty: missing0 },
                  message: "must have required property '" + missing0 + "'",
                },
              ];
              return false;
            } else {
              if (data0.key !== undefined) {
                const _errs3 = errors;
                if (typeof data0.key !== 'string') {
                  validate31.errors = [
                    {
                      instancePath: instancePath + '/' + i0 + '/key',
                      schemaPath: '#/items/properties/key/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid1 = _errs3 === errors;
              } else {
                var valid1 = true;
              }
              if (valid1) {
                if (data0.value !== undefined) {
                  const _errs5 = errors;
                  if (typeof data0.value !== 'string') {
                    validate31.errors = [
                      {
                        instancePath: instancePath + '/' + i0 + '/value',
                        schemaPath: '#/items/properties/value/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid1 = _errs5 === errors;
                } else {
                  var valid1 = true;
                }
                if (valid1) {
                  if (data0.isSelected !== undefined) {
                    const _errs7 = errors;
                    if (typeof data0.isSelected !== 'boolean') {
                      validate31.errors = [
                        {
                          instancePath: instancePath + '/' + i0 + '/isSelected',
                          schemaPath: '#/items/properties/isSelected/type',
                          keyword: 'type',
                          params: { type: 'boolean' },
                          message: 'must be boolean',
                        },
                      ];
                      return false;
                    }
                    var valid1 = _errs7 === errors;
                  } else {
                    var valid1 = true;
                  }
                }
              }
            }
          } else {
            validate31.errors = [
              {
                instancePath: instancePath + '/' + i0,
                schemaPath: '#/items/type',
                keyword: 'type',
                params: { type: 'object' },
                message: 'must be object',
              },
            ];
            return false;
          }
        }
        var valid0 = _errs1 === errors;
        if (!valid0) {
          break;
        }
      }
    } else {
      validate31.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'array' },
          message: 'must be array',
        },
      ];
      return false;
    }
  }
  validate31.errors = vErrors;
  return errors === 0;
}
exports.validateAPIRequestsErrorDistributionData = validate32;
function validate32(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="APIRequestsErrorDistributionData.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.success_data === undefined && (missing0 = 'success_data')) ||
        (data.failure_data === undefined && (missing0 = 'failure_data')) ||
        (data.dates === undefined && (missing0 = 'dates'))
      ) {
        validate32.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.success_data !== undefined) {
          let data0 = data.success_data;
          const _errs1 = errors;
          if (errors === _errs1) {
            if (Array.isArray(data0)) {
              var valid1 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                let data1 = data0[i0];
                const _errs3 = errors;
                if (!(typeof data1 == 'number' && isFinite(data1))) {
                  validate32.errors = [
                    {
                      instancePath: instancePath + '/success_data/' + i0,
                      schemaPath: '#/properties/success_data/items/type',
                      keyword: 'type',
                      params: { type: 'number' },
                      message: 'must be number',
                    },
                  ];
                  return false;
                }
                var valid1 = _errs3 === errors;
                if (!valid1) {
                  break;
                }
              }
            } else {
              validate32.errors = [
                {
                  instancePath: instancePath + '/success_data',
                  schemaPath: '#/properties/success_data/type',
                  keyword: 'type',
                  params: { type: 'array' },
                  message: 'must be array',
                },
              ];
              return false;
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.failure_data !== undefined) {
            let data2 = data.failure_data;
            const _errs5 = errors;
            if (errors === _errs5) {
              if (Array.isArray(data2)) {
                var valid2 = true;
                const len1 = data2.length;
                for (let i1 = 0; i1 < len1; i1++) {
                  let data3 = data2[i1];
                  const _errs7 = errors;
                  if (!(typeof data3 == 'number' && isFinite(data3))) {
                    validate32.errors = [
                      {
                        instancePath: instancePath + '/failure_data/' + i1,
                        schemaPath: '#/properties/failure_data/items/type',
                        keyword: 'type',
                        params: { type: 'number' },
                        message: 'must be number',
                      },
                    ];
                    return false;
                  }
                  var valid2 = _errs7 === errors;
                  if (!valid2) {
                    break;
                  }
                }
              } else {
                validate32.errors = [
                  {
                    instancePath: instancePath + '/failure_data',
                    schemaPath: '#/properties/failure_data/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                  },
                ];
                return false;
              }
            }
            var valid0 = _errs5 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.dates !== undefined) {
              let data4 = data.dates;
              const _errs9 = errors;
              if (errors === _errs9) {
                if (Array.isArray(data4)) {
                  var valid3 = true;
                  const len2 = data4.length;
                  for (let i2 = 0; i2 < len2; i2++) {
                    const _errs11 = errors;
                    if (typeof data4[i2] !== 'string') {
                      validate32.errors = [
                        {
                          instancePath: instancePath + '/dates/' + i2,
                          schemaPath: '#/properties/dates/items/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                    var valid3 = _errs11 === errors;
                    if (!valid3) {
                      break;
                    }
                  }
                } else {
                  validate32.errors = [
                    {
                      instancePath: instancePath + '/dates',
                      schemaPath: '#/properties/dates/type',
                      keyword: 'type',
                      params: { type: 'array' },
                      message: 'must be array',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs9 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate32.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate32.errors = vErrors;
  return errors === 0;
}
exports.validateAPISignatureRequestsData = validate33;
function validate33(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="APISignatureRequestsData.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.count === undefined && (missing0 = 'count')) ||
        (data.page_size === undefined && (missing0 = 'page_size'))
      ) {
        validate33.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.items !== undefined) {
          let data0 = data.items;
          const _errs1 = errors;
          if (errors === _errs1) {
            if (Array.isArray(data0)) {
              var valid1 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                let data1 = data0[i0];
                const _errs3 = errors;
                if (
                  data1 &&
                  typeof data1 == 'object' &&
                  !Array.isArray(data1)
                ) {
                  let missing1;
                  if (
                    (data1.id === undefined && (missing1 = 'id')) ||
                    (data1.status === undefined && (missing1 = 'status')) ||
                    (data1.timestamp === undefined && (missing1 = 'timestamp'))
                  ) {
                    validate33.errors = [
                      {
                        instancePath: instancePath + '/items/' + i0,
                        schemaPath: '#/properties/items/items/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message:
                          "must have required property '" + missing1 + "'",
                      },
                    ];
                    return false;
                  } else {
                    if (data1.id !== undefined) {
                      const _errs4 = errors;
                      if (typeof data1.id !== 'string') {
                        validate33.errors = [
                          {
                            instancePath: instancePath + '/items/' + i0 + '/id',
                            schemaPath:
                              '#/properties/items/items/properties/id/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid2 = _errs4 === errors;
                    } else {
                      var valid2 = true;
                    }
                    if (valid2) {
                      if (data1.status !== undefined) {
                        const _errs6 = errors;
                        if (typeof data1.status !== 'string') {
                          validate33.errors = [
                            {
                              instancePath:
                                instancePath + '/items/' + i0 + '/status',
                              schemaPath:
                                '#/properties/items/items/properties/status/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid2 = _errs6 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data1.timestamp !== undefined) {
                          let data4 = data1.timestamp;
                          const _errs8 = errors;
                          if (!(typeof data4 == 'number' && isFinite(data4))) {
                            validate33.errors = [
                              {
                                instancePath:
                                  instancePath + '/items/' + i0 + '/timestamp',
                                schemaPath:
                                  '#/properties/items/items/properties/timestamp/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number',
                              },
                            ];
                            return false;
                          }
                          var valid2 = _errs8 === errors;
                        } else {
                          var valid2 = true;
                        }
                      }
                    }
                  }
                }
                var valid1 = _errs3 === errors;
                if (!valid1) {
                  break;
                }
              }
            } else {
              validate33.errors = [
                {
                  instancePath: instancePath + '/items',
                  schemaPath: '#/properties/items/type',
                  keyword: 'type',
                  params: { type: 'array' },
                  message: 'must be array',
                },
              ];
              return false;
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.count !== undefined) {
            let data5 = data.count;
            const _errs10 = errors;
            if (!(typeof data5 == 'number' && isFinite(data5))) {
              validate33.errors = [
                {
                  instancePath: instancePath + '/count',
                  schemaPath: '#/properties/count/type',
                  keyword: 'type',
                  params: { type: 'number' },
                  message: 'must be number',
                },
              ];
              return false;
            }
            var valid0 = _errs10 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.page_size !== undefined) {
              let data6 = data.page_size;
              const _errs12 = errors;
              if (!(typeof data6 == 'number' && isFinite(data6))) {
                validate33.errors = [
                  {
                    instancePath: instancePath + '/page_size',
                    schemaPath: '#/properties/page_size/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                  },
                ];
                return false;
              }
              var valid0 = _errs12 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate33.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate33.errors = vErrors;
  return errors === 0;
}
exports.validateAPISearchResultData = validate34;
function validate34(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="APISearchResultData.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (data.result_counts === undefined && (missing0 = 'result_counts')) {
        validate34.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.page_size !== undefined) {
          let data0 = data.page_size;
          const _errs1 = errors;
          if (!(typeof data0 == 'number' && isFinite(data0))) {
            validate34.errors = [
              {
                instancePath: instancePath + '/page_size',
                schemaPath: '#/properties/page_size/type',
                keyword: 'type',
                params: { type: 'number' },
                message: 'must be number',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.result_counts !== undefined) {
            let data1 = data.result_counts;
            const _errs3 = errors;
            if (errors === _errs3) {
              if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                let missing1;
                if (
                  (data1.signature_request === undefined &&
                    (missing1 = 'signature_request')) ||
                  (data1.api_request === undefined &&
                    (missing1 = 'api_request')) ||
                  (data1.account_callback === undefined &&
                    (missing1 = 'account_callback')) ||
                  (data1.app_callback === undefined &&
                    (missing1 = 'app_callback'))
                ) {
                  validate34.errors = [
                    {
                      instancePath: instancePath + '/result_counts',
                      schemaPath: '#/properties/result_counts/required',
                      keyword: 'required',
                      params: { missingProperty: missing1 },
                      message: "must have required property '" + missing1 + "'",
                    },
                  ];
                  return false;
                } else {
                  if (data1.signature_request !== undefined) {
                    let data2 = data1.signature_request;
                    const _errs5 = errors;
                    if (!(typeof data2 == 'number' && isFinite(data2))) {
                      validate34.errors = [
                        {
                          instancePath:
                            instancePath + '/result_counts/signature_request',
                          schemaPath:
                            '#/properties/result_counts/properties/signature_request/type',
                          keyword: 'type',
                          params: { type: 'number' },
                          message: 'must be number',
                        },
                      ];
                      return false;
                    }
                    var valid1 = _errs5 === errors;
                  } else {
                    var valid1 = true;
                  }
                  if (valid1) {
                    if (data1.api_request !== undefined) {
                      let data3 = data1.api_request;
                      const _errs7 = errors;
                      if (!(typeof data3 == 'number' && isFinite(data3))) {
                        validate34.errors = [
                          {
                            instancePath:
                              instancePath + '/result_counts/api_request',
                            schemaPath:
                              '#/properties/result_counts/properties/api_request/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                          },
                        ];
                        return false;
                      }
                      var valid1 = _errs7 === errors;
                    } else {
                      var valid1 = true;
                    }
                    if (valid1) {
                      if (data1.account_callback !== undefined) {
                        let data4 = data1.account_callback;
                        const _errs9 = errors;
                        if (!(typeof data4 == 'number' && isFinite(data4))) {
                          validate34.errors = [
                            {
                              instancePath:
                                instancePath +
                                '/result_counts/account_callback',
                              schemaPath:
                                '#/properties/result_counts/properties/account_callback/type',
                              keyword: 'type',
                              params: { type: 'number' },
                              message: 'must be number',
                            },
                          ];
                          return false;
                        }
                        var valid1 = _errs9 === errors;
                      } else {
                        var valid1 = true;
                      }
                      if (valid1) {
                        if (data1.app_callback !== undefined) {
                          let data5 = data1.app_callback;
                          const _errs11 = errors;
                          if (!(typeof data5 == 'number' && isFinite(data5))) {
                            validate34.errors = [
                              {
                                instancePath:
                                  instancePath + '/result_counts/app_callback',
                                schemaPath:
                                  '#/properties/result_counts/properties/app_callback/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number',
                              },
                            ];
                            return false;
                          }
                          var valid1 = _errs11 === errors;
                        } else {
                          var valid1 = true;
                        }
                      }
                    }
                  }
                }
              } else {
                validate34.errors = [
                  {
                    instancePath: instancePath + '/result_counts',
                    schemaPath: '#/properties/result_counts/type',
                    keyword: 'type',
                    params: { type: 'object' },
                    message: 'must be object',
                  },
                ];
                return false;
              }
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate34.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate34.errors = vErrors;
  return errors === 0;
}
exports.validateAPIIncidentsData = validate15;
exports.validateAPIRequestsEndpointData = validate17;
exports.validateTeamAccountsData = validate19;
exports.validateTeamData = validate20;
exports.validateAccountData = validate35;
function validate35(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="AccountData.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.account_guid === undefined && (missing0 = 'account_guid')) ||
        (data.email_address === undefined && (missing0 = 'email_address'))
      ) {
        validate35.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.account_guid !== undefined) {
          const _errs1 = errors;
          if (typeof data.account_guid !== 'string') {
            validate35.errors = [
              {
                instancePath: instancePath + '/account_guid',
                schemaPath: '#/properties/account_guid/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.first_name !== undefined) {
            let data1 = data.first_name;
            const _errs3 = errors;
            if (typeof data1 !== 'string' && data1 !== null) {
              validate35.errors = [
                {
                  instancePath: instancePath + '/first_name',
                  schemaPath: '#/properties/first_name/type',
                  keyword: 'type',
                  params: { type: schema38.properties.first_name.type },
                  message: 'must be string,null',
                },
              ];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.last_name !== undefined) {
              let data2 = data.last_name;
              const _errs5 = errors;
              if (typeof data2 !== 'string' && data2 !== null) {
                validate35.errors = [
                  {
                    instancePath: instancePath + '/last_name',
                    schemaPath: '#/properties/last_name/type',
                    keyword: 'type',
                    params: { type: schema38.properties.last_name.type },
                    message: 'must be string,null',
                  },
                ];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.email_address !== undefined) {
                const _errs7 = errors;
                if (typeof data.email_address !== 'string') {
                  validate35.errors = [
                    {
                      instancePath: instancePath + '/email_address',
                      schemaPath: '#/properties/email_address/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.role !== undefined) {
                  const _errs9 = errors;
                  if (typeof data.role !== 'string') {
                    validate35.errors = [
                      {
                        instancePath: instancePath + '/role',
                        schemaPath: '#/properties/role/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate35.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate35.errors = vErrors;
  return errors === 0;
}
